<template lang="html">
  <div>
    <p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>800.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 6 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>689.66 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 5 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-20000MB_ilim2_6m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-20000MB_ilim2_6m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_ilim2_6m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>1,200.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 6 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>1,034.48 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 5 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-5000MB_ilim_12m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-5000MB_ilim_12m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB_ilim_12m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>700.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 12 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>603.45 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 11 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-20000MB_ilim_12m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-20000MB_ilim_12m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_ilim_12m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>1,400.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 12 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>1,206.90 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 11 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0621-20000MB_ilim2_12m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0621-20000MB_ilim2_12m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_ilim2_12m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>2,100.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 12 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>1,810.34 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 11 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0921-5000MB_ilim_24m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0921-5000MB_ilim_24m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB_ilim_24m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>1,900.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 24 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>1,637.93 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 23 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0921-20000MB_ilim_24m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0921-20000MB_ilim_24m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_ilim_24m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>3,800.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 24 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>3,275.86 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 23 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, no podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0921-20000MB_ilim2_24m_PA]</p>
<p>&nbsp;</p>
<h3>ANEXO 0921-20000MB_ilim2_24m_PA</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB_ilim2_24m_PA incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="165">
<p>5,700.00 MXN</p>
</td>
<td width="299">
<p>Contrataci&oacute;n de una l&iacute;nea para 24 meses continuos de servicio.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="165">
<p>4,913.79 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="165">
<p>30 d&iacute;as o una fecha inicio una fecha fin entre la que transcurre un mes calendario.</p>
</td>
<td width="299">
<p>A partir de su activaci&oacute;n esta oferta tendr&aacute; 23 renovaciones autom&aacute;ticas en las que se asignar&aacute;n nuevamente los vol&uacute;menes correspondientes a los servicios de Datos, Voz y SMS.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un Paquete de Consumo Excedente, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de 512 Kbps.</p>
</td>
</tr>
<tr>
<td width="186">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="186">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="299">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="302">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="183">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="165">
<p>&nbsp;</p>
<p>1000</p>
</td>
<td width="302">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="164">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="302">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;..</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="467">
<p>&nbsp;</p>
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO; SIGUE EN ANEXO 0320-5000MB_2000MBRS30D]</p>
<p>&nbsp;</p>
<h3>ANEXO 0320-5000MB_2000MBRS30D</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB_2000MBRS30D incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="339">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="295">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="133">
<p>140.00 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="133">
<p>120.69 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="295">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="133">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="295">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de [●] Kbps.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="295">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins</strong></p>
<p><strong>/ Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
</td>
<td width="133">
<p>&nbsp;</p>
</td>
<td width="295">
<p>nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente&nbsp; en&nbsp; Roaming&nbsp; Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="428">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="428">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="635">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADA EN BLANCO, SIGUE ANEXO DE 1220-1000MB_300MBRS30D_NB28]</p>
<p>&nbsp;</p>
<h3>ANEXO 1220-1000MB_300MBRS30D_NB28</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 1000MB_300MBRS30D_NB28 incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="339">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="295">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="133">
<p>100.00 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="133">
<p>86.21 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="295">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="133">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="295">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de [●] Kbps.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>300</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="295">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;. No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins</strong></p>
<p><strong>/ Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
</td>
<td width="133">
<p>&nbsp;</p>
</td>
<td width="295">
<p>nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente&nbsp; en&nbsp; Roaming&nbsp; Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="428">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="428">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="635">
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 1220-2000MB_500MBRS30D_NB28</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 2000MB_500MBRS30D_NB28 incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="339">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="295">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="133">
<p>150.00 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="133">
<p>129.31 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="295">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="133">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="295">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de [●] Kbps.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="295">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;.</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins</strong></p>
<p><strong>/ Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="295">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
</td>
<td width="133">
<p>&nbsp;</p>
</td>
<td width="295">
<p>como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="428">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="428">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="635">
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>ANEXO 1220-4000MB_2000MBRS30D_NB28</p>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 4000MB_2000MBRS30D_N28 incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="339">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="295">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="133">
<p>300.00 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="133">
<p>258.62 MXN</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="295">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="133">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="295">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>4,000</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional y en Roaming Internacional cursados en una red en EUA y Canad&aacute;.</p>
<p>Al finalizar la Cuota de Datos el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>4,000</p>
</td>
<td width="295">
<p>La Cuota de Datos incluye consumos de Roaming Internacional cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Consumo Excedente a Velocidad Reducida (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>No Incluido</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Los MB incluidos dentro del Consumo Excedente a Velocidad Reducida, aplican para consumo de Datos Nacional a una velocidad m&aacute;xima de navegaci&oacute;n downlink de [●] Kbps.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="295">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Volumen de Datos a URL plana de soporte a Usuario Final (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>Aplica para consumo de Datos Nacional. Sujeto a viabilidad t&eacute;cnica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>Permitido</p>
</td>
<td width="295">
<p>Los Datos asociados a este Producto bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;.</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins</strong></p>
<p><strong>/ Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>750</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="295">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; y destino a una red en M&eacute;xico, EUA y Canad&aacute;; y</p>
<p>&times;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
<p>&nbsp;</p>
<p>No aplica para servicios de Tarificaci&oacute;n Adicional.</p>
<p>&nbsp;</p>
<p>Una vez superado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente el Cliente podr&aacute;: i) contratar un nuevo Producto, o ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="207">
<p>&nbsp;</p>
</td>
<td width="133">
<p>&nbsp;</p>
</td>
<td width="295">
<p>como: cursar tr&aacute;fico bajo la Estructura Tarifaria Granel, suspensi&oacute;n, u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="207">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="133">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="295">
<p>&nbsp;</p>
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>&times; SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="428">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="207">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="428">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="635">
<p>Para los Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Redes Sociales &ldquo;RRSS&rdquo; aplicar&aacute;n las condiciones generales de uso descritas en este Ap&eacute;ndice 11.3.</p>
<p>&nbsp;</p>
<p>Esta oferta es de uso exclusivo en dispositivos m&oacute;viles que soporten voz y sms.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0421-10000MB7D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 10000MB7D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>80.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>68.97 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>7 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre una semana natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0421-20000MB7D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB7D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>140.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>120.69 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>7 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre una semana natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-5000MB30D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB30D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>100.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>86.21 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-10000MB30D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 10000MB30D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>175.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>150.86 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-20000MB30D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB30D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>300.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>258.62 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-30000MB30D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 30000MB30D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>400.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>344.83 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>30,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>&nbsp;</p>
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-50000MB30D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 50000MB30D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>500.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>431.03 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>50,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-80000MB30D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 80000MB30D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>800.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>689.66 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>80,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-100000MB30D_MiFi_BE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 100000MB30D_MiFi_BE incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>1000.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>862.07 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>40%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>100,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos &uacute;nicamente en Cobertura de la Red Compartida. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0421-10000MB7D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 10000MB7D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>80.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>68.97 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>7 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre una semana natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>&Uacute;nicamente se puede consumir el 50% de la cuota de datos fuera de Huella Altan.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0421-20000MB7D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB7D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>140.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>120.69 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>7 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre una semana natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>&Uacute;nicamente se puede consumir el 50% de la cuota de datos fuera de Huella Altan.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-5000MB30D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 5000MB30D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>100.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>86.21 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-10000MB30D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 10000MB30D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>175.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>150.86 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>10,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-20000MB30D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 20000MB30D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>300.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>258.62 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>20,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>&nbsp;</p>
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-30000MB30D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 30000MB30D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>400.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>344.83 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>30,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0520-50000MB30D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 50000MB30D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>500.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>431.03 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>50,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-80000MB30D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 80000MB30D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>800.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>689.66 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>80,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-100000MB30D_MiFi_BE_TN</h3>
<p>El presente anexo describe el detalle de condiciones aplicables al producto 100000MB30D_MiFi_BE_TN incluido en la Tabla 7 del Ap&eacute;ndice 11.3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo;</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="351">
<p><strong>Paquete Principal</strong></p>
</td>
<td width="299">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (despu&eacute;s de IVA)</strong></p>
</td>
<td width="137">
<p>1000.00 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Precio de Referencia (antes de IVA)</strong></p>
</td>
<td width="137">
<p>862.07 MXN</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="299">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="137">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="299">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="214">
<p><strong>Velocidad del Producto (Mbps)</strong></p>
</td>
<td width="137">
<p>Best Effort</p>
</td>
<td width="299">
<p>Velocidad de navegaci&oacute;n downlink</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>100,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos con Cobertura en Territorio Nacional.</p>
<p>Al finalizar este paquete el Cliente podr&aacute;: i) contratar un nuevo Producto, y/o ii) contratar un Paquete de Consumo Excedente, y/o iii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="137">
<p>&nbsp;</p>
<p>3,000</p>
</td>
<td width="299">
<p>Aplica para consumo de Datos Nacional. Al finalizar el consumo en RRSS disponible, los consumos de este tr&aacute;fico se descontar&aacute;n de la Cuota de Datos si se tuvieran a&uacute;n MB disponibles.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="214">
<p>&nbsp;</p>
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="436">
<p>&nbsp;</p>
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td colspan="3" width="650">
<p>Este Producto Empaquetado s&oacute;lo podr&aacute; ser utilizado en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<p>Los servicios de Voz y SMS no est&aacute;n disponibles con Productos MiFi (o s&oacute;lo Datos).</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-1000MB_PDUV</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Datos en Usuario Visitante:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="257">
<p><strong>Paquete de Datos en Usuario Visitante</strong></p>
</td>
<td width="152">
<p><strong>Paquete de 1,000 MB</strong></p>
</td>
<td width="241">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="152">
<p>80.00 MXN</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="152">
<p>68.97 MXN</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="152">
<p>&nbsp;</p>
<p>25%</p>
</td>
<td width="241">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="152">
<p>60 d&iacute;as</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="241">
<p>Aplica para consumo de Datos &uacute;nicamente en Usuario Visitante, siempre y cuando se tenga con un Producto activo.</p>
<p>&nbsp;</p>
<p>Al finalizar este paquete el cliente podr&aacute;: i) contratar un nuevo Producto, ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n,&nbsp;&nbsp; portal&nbsp;&nbsp; cautivo&nbsp;&nbsp; u&nbsp;&nbsp; otras de</p>
<p>similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>No Aplica</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>No Aplica</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>No Aplica</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="394">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="394">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="394">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-2000MB_PDUV</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Datos en Usuario Visitante:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="257">
<p><strong>Paquete de Datos en Usuario Visitante</strong></p>
</td>
<td width="152">
<p><strong>Paquete de 2,000 MB</strong></p>
</td>
<td width="241">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="152">
<p>160.00 MXN</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="152">
<p>137.93 MXN</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="152">
<p>&nbsp;</p>
<p>25%</p>
</td>
<td width="241">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="152">
<p>120 d&iacute;as</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>&nbsp;</p>
<p>2,000</p>
</td>
<td width="241">
<p>Aplica para consumo de Datos &uacute;nicamente en Usuario Visitante, siempre y cuando se tenga con un Producto activo.</p>
<p>&nbsp;</p>
<p>Al finalizar este paquete el cliente podr&aacute;: i) contratar un nuevo Producto, ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>No Aplica</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>No Aplica</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="152">
<p>No Aplica</p>
</td>
<td width="241">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="394">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="394">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="257">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="394">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-5000MB_PDUV</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Datos en Usuario Visitante:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="270">
<p><strong>Paquete de Datos en Usuario Visitante</strong></p>
</td>
<td width="141">
<p><strong>Paquete de 5,000 MB</strong></p>
</td>
<td width="240">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="141">
<p>400.00 MXN</p>
</td>
<td width="240">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="141">
<p>344.83 MXN</p>
</td>
<td width="240">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="270">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="141">
<p>&nbsp;</p>
<p>25%</p>
</td>
<td width="240">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="141">
<p>365 d&iacute;as</p>
</td>
<td width="240">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="270">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="141">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="240">
<p>Aplica para consumo de Datos &uacute;nicamente en Usuario Visitante, siempre y cuando se tenga con un Producto activo.</p>
<p>&nbsp;</p>
<p>Al finalizar este paquete el cliente podr&aacute;:</p>
<p>i) contratar un nuevo Producto, ii) solicitar que se ejecute otra acci&oacute;n entre las configuradas para su producto como: suspensi&oacute;n, portal cautivo u otras de similar naturaleza.</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="141">
<p>No Aplica</p>
</td>
<td width="240">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="141">
<p>No Aplica</p>
</td>
<td width="240">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="141">
<p>No Aplica</p>
</td>
<td width="240">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="381">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="381">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="270">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="381">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-70U_PVSMSLDI</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Voz y SMS en LDI:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="216">
<p><strong>Paquete de Voz y SMS para Larga Distancia Internacional</strong></p>
</td>
<td width="176">
<p><strong>Paquete de 70 Unidades</strong></p>
</td>
<td width="258">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="176">
<p>100.00 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="176">
<p>86.21 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>15%</p>
</td>
<td width="258">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="176">
<p>30 d&iacute;as</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Unidades Incluidas (Paquetes / Ciclo Individual)</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>60 minutos y 10 SMS</p>
</td>
<td width="258">
<p>Las unidades incluidas en el paquete de Voz y SMS incluyen LDI con destino a Latinoam&eacute;rica (excl. Caribe)</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="434">
<p>Latinoam&eacute;rica (excl. Caribe)</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="434">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="434">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="434">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-40U_PVSMSLDIE</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Voz y SMS en LDI:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="216">
<p><strong>Paquete de Voz y SMS para Larga Distancia Internacional</strong></p>
</td>
<td width="176">
<p><strong>Paquete de 40 Unidades</strong></p>
</td>
<td width="258">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="176">
<p>100.00 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="176">
<p>86.21 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>15%</p>
</td>
<td width="258">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="176">
<p>30 d&iacute;as</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Unidades Incluidas (Paquetes / Ciclo Individual)</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>30 minutos y 10 SMS</p>
</td>
<td width="258">
<p>&nbsp;</p>
<p>Las unidades incluidas en el paquete de Voz y SMS incluyen LDI con destino a Europa</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="434">
<p>Europa</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="434">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="434">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="434">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-40U_PVSMSLDIRM</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Voz y SMS en LDI:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="216">
<p><strong>Paquete de Voz y SMS para Larga Distancia Internacional</strong></p>
</td>
<td width="176">
<p><strong>Paquete de 40 Unidades</strong></p>
</td>
<td width="258">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="176">
<p>200.00 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="176">
<p>172.41 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>15%</p>
</td>
<td width="258">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="176">
<p>30 d&iacute;as</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Unidades Incluidas (Paquetes / Ciclo Individual)</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>30 minutos y 10 SMS</p>
</td>
<td width="258">
<p>Las unidades incluidas en el paquete de Voz y SMS incluyen LDI con destino al Resto del Mundo excl. Destinos Especiales;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="434">
<p>Resto del Mundo excluyendo Destinos Especiales</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="434">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="434">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="434">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-25U_PVSMSLDIRM</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Voz y SMS en LDI:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="216">
<p><strong>Paquete de Voz y SMS para Larga Distancia Internacional</strong></p>
</td>
<td width="176">
<p><strong>Paquete de 25 Unidades</strong></p>
</td>
<td width="258">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="176">
<p>100.00 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="176">
<p>86.21 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>15%</p>
</td>
<td width="258">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="176">
<p>30 d&iacute;as</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Unidades Incluidas (Paquetes / Ciclo Individual)</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>15 minutos y 10 SMS</p>
</td>
<td width="258">
<p>Las unidades incluidas en el paquete de Voz y SMS incluyen LDI con destino al Resto del Mundo excl. Destinos Especiales;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="434">
<p>Resto del Mundo excluyendo Destinos Especiales</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="434">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="434">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="434">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-1000MB_PCED</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excedente de Datos:</p>

<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="223">
<p><strong>Paquete Consumo Excedente de Datos</strong></p>
</td>
<td width="163">
<p><strong>Paquete de 1,000 MB</strong></p>
</td>
<td width="264">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="163">
<p>30.00 MXN</p>
</td>
<td width="264">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="163">
<p>25.86 MXN</p>
</td>
<td width="264">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="223">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="163">
<p>&nbsp;</p>
<p>25%</p>
</td>
<td width="264">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="223">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="163">
<p>Mismo Ciclo Individual del Producto al que est&aacute;n asociados</p>
</td>
<td width="264">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="223">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="163">
<p>&nbsp;</p>
<p>1,000</p>
</td>
<td width="264">
<p>Aplica para consumo de Datos Nacional. En caso de activarse junto con un Producto MiFi, las condiciones de uso de este</p>
<p>Paquete de Consumo Excedente ser&aacute;n las mismas a las del Producto MiFi contratado.</p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo</strong></p>
<p><strong>Individual)</strong></p>
</td>
<td width="163">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="264">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo</strong></p>
<p><strong>Individual)</strong></p>
</td>
<td width="163">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="264">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="163">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="264">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="428">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="428">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="223">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="428">
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td width="223">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="428">
<p>&Uacute;nicamente los Productos empaquetados incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-2500MB_PCED</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excedente de Datos:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p><strong>Paquete Consumo Excedente de Datos</strong></p>
</td>
<td width="181">
<p><strong>Paquete de 2,500 MB</strong></p>
</td>
<td width="257">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="181">
<p>50.00 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="181">
<p>43.10 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>25%</p>
</td>
<td width="257">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="181">
<p>Mismo Ciclo Individual del Producto al que est&aacute;n asociados</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>2,500</p>
</td>
<td width="257">
<p>Aplica para consumo de Datos Nacional. En caso de activarse junto con un Producto MiFi, las condiciones de uso de este Paquete de</p>
<p>Consumo Excedente ser&aacute;n las mismas a las del Producto MiFi contratado.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final /</strong></p>
<p><strong>Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="438">
<p>&Uacute;nicamente los Productos empaquetados incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N:</p>
<p>GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-5000MB_PCED</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excendente de Datos:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p><strong>Paquete Consumo Excedente de Datos</strong></p>
</td>
<td width="181">
<p><strong>Paquete de 5,000 MB</strong></p>
</td>
<td width="257">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="181">
<p>100.00 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="181">
<p>86.20 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>25%</p>
</td>
<td width="257">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="181">
<p>Mismo Ciclo Individual del Producto al que est&aacute;n asociados</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Cuota de Datos (MB / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>5,000</p>
</td>
<td width="257">
<p>Aplica para consumo de Datos Nacional. En caso de activarse junto con un Producto MiFi, las condiciones de uso de este Paquete de Consumo Excedente ser&aacute;n las mismas a las del Producto MiFi contratado.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="438">
<p>No Aplica.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="438">
<p>&Uacute;nicamente los Productos empaquetados incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL</p>
<p>FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-1000MB_PCEVDSMS</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excedente de Voz, Datos y SMS:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="195">
<p><strong>Paquete de Consumo Excedente</strong></p>
</td>
<td width="114">
<p><strong>Voz, Datos y SMS</strong></p>
</td>
<td width="342">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="114">
<p>50.00 MXN</p>
</td>
<td width="342">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="114">
<p>43.10 MXN</p>
</td>
<td width="342">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="195">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="114">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="342">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="195">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="114">
<p>Mismo Ciclo Individual del</p>
<p>Producto al que est&aacute;n asociados</p>
</td>
<td width="342">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>Cuota de Datos (MB / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="114">
<p>1,000</p>
</td>
<td width="342">
<p>Aplica para consumo de Datos Nacional.</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="114">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="342">
<p>Aplica para consumos de Datos en Roaming Internacional, cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del Ciclo</p>
<p>Individual.</p>
</td>
</tr>
<tr>
<td width="195">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="114">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="342">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="195">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="114">
<p>&nbsp;</p>
<p>125</p>
</td>
<td width="342">
<p>Aplica para consumo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="114">
<p>&nbsp;</p>
<p>50</p>
</td>
<td width="342">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="195">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="114">
<p>&nbsp;</p>
<p>25</p>
</td>
<td width="342">
<p>Aplica para consumo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>- SMS Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en</p>
<p>Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="114">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="342">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="456">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="456">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="195">
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="456">
<p>&Uacute;nicamente los Productos empaquetados incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y</p>
<p>PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-2500MB_PCEVDSMS</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excedente de Voz, Datos y SMS:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p><strong>Paquete de Consumo Excedente</strong></p>
</td>
<td width="129">
<p><strong>Voz, Datos y SMS</strong></p>
</td>
<td width="309">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="129">
<p>100.00 MXN</p>
</td>
<td width="309">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="129">
<p>86.20 MXN</p>
</td>
<td width="309">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="309">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada</p>
<p>Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="129">
<p>Mismo Ciclo Individual del Producto al que est&aacute;n asociados</p>
</td>
<td width="309">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Cuota de Datos (MB / Usuario Final /</strong></p>
<p><strong>Ciclo Individual)</strong></p>
</td>
<td width="129">
<p>2,500</p>
</td>
<td width="309">
<p>Aplica para consumo de Datos Nacional.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Datos en Roaming Internacional (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>1,250</p>
</td>
<td width="309">
<p>Aplica para consumos de Datos en Roaming Internacional, cursados en una red en EUA y Canad&aacute; hasta un m&aacute;ximo medido en MB que el Usuario Final puede usar dentro del</p>
<p>Ciclo Individual.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>500</p>
</td>
<td width="309">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente incluye los siguientes consumos:</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente Nacional con destino nacional;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de Voz con destino EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz en Roaming Internacional (Mins / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>250</p>
</td>
<td width="309">
<p>Aplica para consumo de Tr&aacute;fico de Voz en Roaming Internacional incluye los siguientes consumos:</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente en Roaming Internacional con origen en una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red en EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>100</p>
</td>
<td width="309">
<p>El L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente incluye los siguientes consumos:</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Saliente Nacional con destino nacional;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; LDI de SMS con destino EUA y Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS en Roaming Internacional (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>50</p>
</td>
<td width="309">
<p>Aplica para consumo de Tr&aacute;fico de SMS en Roaming Internacional incluye los siguientes consumos:</p>
<p>- SMS Saliente en Roaming Internacional con origen en</p>
<p>una red en EUA y Canad&aacute; con destino a una red en M&eacute;xico, EUA o en Canad&aacute;.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="309">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="438">
<p>&Uacute;nicamente los Productos empaquetados incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo</p>
<p>definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-500M_PCEV</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excedente de Voz:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="261">
<p><strong>Paquete de Consumo Excedente de Voz</strong></p>
</td>
<td width="212">
<p><strong>Paquete de Voz</strong></p>
</td>
<td width="177">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="212">
<p>50.00 MXN</p>
</td>
<td width="177">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="212">
<p>43.10 MXN</p>
</td>
<td width="177">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="261">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="212">
<p>&nbsp;</p>
<p>25%</p>
</td>
<td width="177">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="212">
<p>Mismo Ciclo Individual del Producto al que est&aacute;n asociados</p>
</td>
<td width="177">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="212">
<p>No Aplica</p>
</td>
<td width="177">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="212">
<p>500</p>
</td>
<td width="177">
<p>Aplica para consumo de Tr&aacute;fico de Voz Nacional.</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="212">
<p>No Aplica</p>
</td>
<td width="177">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="212">
<p>No Aplica</p>
</td>
<td width="177">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="389">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="261">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="389">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="261">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="389">
<p>&Uacute;nicamente los Productos empaquetados incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN</p>
<p>PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-3D_TT</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excendente de Datos:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p><strong>Paquete Consumo Excedente de Datos</strong></p>
</td>
<td width="181">
<p><strong>Paquete de 3 d&iacute;as</strong></p>
</td>
<td width="257">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="181">
<p>15.00 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="181">
<p>12.93 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="257">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="181">
<p>3 d&iacute;as</p>
<p>El producto al que est&eacute; asociado deber&aacute; tener el mismo Ciclo de Vida Inidividual</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Cuota de Datos (MB / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td colspan="2" width="438">
<p>Este Producto habilita la compartici&oacute;n de la Cuota de Datos al Producto que sea asociado bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>Hasta el 31 de diciembre 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="438">
<p>&Uacute;nicamente los Productos empaquetdos con ciclo individual de 3 d&iacute;as incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-7D_TT</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excendente de Datos:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p><strong>Paquete Consumo Excedente de Datos</strong></p>
</td>
<td width="181">
<p><strong>Paquete de 7 d&iacute;as</strong></p>
</td>
<td width="257">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="181">
<p>25.00 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="181">
<p>21.55 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="257">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="181">
<p>7 d&iacute;as</p>
<p>El productoal que est&eacute; asociado deber&aacute; tener el mismo Ciclo de Vida Inidividual</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Cuota de Datos (MB / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td colspan="2" width="438">
<p>Este Producto habilita la compartici&oacute;n de la Cuota de Datos al Producto que sea asociado bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="438">
<p>&Uacute;nicamente los Productos empaquetdos con ciclo individual de 7 d&iacute;as incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-15D_TT</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excendente de Datos:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p><strong>Paquete Consumo Excedente de Datos</strong></p>
</td>
<td width="181">
<p><strong>Paquete de 15 d&iacute;as</strong></p>
</td>
<td width="257">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="181">
<p>50.00 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="181">
<p>43.10 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="257">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="181">
<p>15 d&iacute;as</p>
<p>El productoal que est&eacute; asociado deber&aacute; tener el mismo Ciclo de Vida Inidividual</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Cuota de Datos (MB / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td colspan="2" width="438">
<p>Este Producto habilita la compartici&oacute;n de la Cuota de Datos al Producto que sea asociado bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="438">
<p>&Uacute;nicamente los Productos empaquetdos con ciclo individual de 15 d&iacute;as incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0521-30D_TT</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Consumo Excendente de Datos:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="212">
<p><strong>Paquete Consumo Excedente de Datos</strong></p>
</td>
<td width="181">
<p><strong>Paquete de 30 d&iacute;as</strong></p>
</td>
<td width="257">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="181">
<p>100.00 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="181">
<p>86.21 MXN</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>35%</p>
</td>
<td width="257">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 8 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="181">
<p>30 d&iacute;as</p>
<p>El productoal que est&eacute; asociado deber&aacute; tener el mismo Ciclo de Vida Inidividual.</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Cuota de Datos (MB / Usuario Final</strong></p>
<p><strong>/ Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="181">
<p>&nbsp;</p>
<p>No Aplica</p>
</td>
<td width="257">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Funcionalidad de compartici&oacute;n de Datos</strong></p>
</td>
<td colspan="2" width="438">
<p>Este Producto habilita la compartici&oacute;n de la Cuota de Datos al Producto que sea asociado bajo los conceptos de Cuota de Datos, Consumo Excedente a Velocidad Reducida y/o L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS, podr&aacute;n ser compartidos (funcionalidad com&uacute;nmente conocida como &ldquo;Hotspot&rdquo; o &ldquo;Tethering&rdquo;).</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="438">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="212">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="438">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="212">
<p>&nbsp;</p>
<p><strong>Productos combinables con este paquete</strong></p>
</td>
<td colspan="2" width="438">
<p>&Uacute;nicamente los Productos empaquetdos con ciclo individual de 30 d&iacute;as incluidos en la Tabla 7 de este Ap&eacute;ndice que s&oacute;lo puedan ser utilizados en equipos compatibles con la Red Alt&aacute;n seg&uacute;n lo definido en el Ap&eacute;ndice 11.1 Alcance t&eacute;cnico: MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0421-500MB_PDRI-LEUC</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Datos en Roaming Internacional:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="286">
<p><strong>Paquete de Datos en Roaming Internacional</strong></p>
</td>
<td width="144">
<p><strong>Paquete de 500 MB</strong></p>
</td>
<td width="220">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="144">
<p>349.00 MXN</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="144">
<p>300.86 MXN</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="144">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="220">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="286">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="144">
<p>30 d&iacute;as, o una fecha inicio una fecha fin</p>
<p>entre las que transcurre un mes natural</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo</strong></p>
<p><strong>Individual)</strong></p>
</td>
<td width="144">
<p>500</p>
</td>
<td width="220">
<p>Aplica para consumo de Datos en los</p>
<p>pa&iacute;ses incluidos dentro del paquete.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS</strong></p>
<p><strong>/ Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="364">
<p>Latinoam&eacute;rica (excl. Caribe) y Estados Unidos y Canad&aacute;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="364">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="364">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="364">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0421-500MB_PDRI-EAAO</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Datos en Roaming Internacional:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="286">
<p><strong>Paquete de Datos en Roaming Internacional</strong></p>
</td>
<td width="144">
<p><strong>Paquete de 500 MB</strong></p>
</td>
<td width="220">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="144">
<p>699.00 MXN</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="144">
<p>602.59 MXN</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="144">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="220">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="286">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="144">
<p>30 d&iacute;as, o una fecha inicio una fecha fin</p>
<p>entre las que transcurre un mes natural</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo</strong></p>
<p><strong>Individual)</strong></p>
</td>
<td width="144">
<p>500</p>
</td>
<td width="220">
<p>Aplica para consumo de Datos en los</p>
<p>pa&iacute;ses incluidos dentro del paquete.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS</strong></p>
<p><strong>/ Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="364">
<p>Europa, Asia, &Aacute;frica y Ocean&iacute;a</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="364">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="364">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="364">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0421-1000MB_PDRI-EAAO</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Datos en Roaming Internacional:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="286">
<p><strong>Paquete de Datos en Roaming Internacional</strong></p>
</td>
<td width="144">
<p><strong>Paquete de 1000 MB</strong></p>
</td>
<td width="220">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="144">
<p>999.00 MXN</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="144">
<p>861.21 MXN</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="144">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="220">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="286">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="144">
<p>30 d&iacute;as, o una fecha inicio una fecha fin</p>
<p>entre las que transcurre un mes natural</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo</strong></p>
<p><strong>Individual)</strong></p>
</td>
<td width="144">
<p>1000</p>
</td>
<td width="220">
<p>Aplica para consumo de Datos en los</p>
<p>pa&iacute;ses incluidos dentro del paquete.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Minutos / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Saliente (SMS</strong></p>
<p><strong>/ Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de RRSS en Cobertura (MB / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="144">
<p>No Aplica</p>
</td>
<td width="220">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="364">
<p>Europa, Asia, &Aacute;frica y Ocean&iacute;a</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="364">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="364">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="286">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="364">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 1021-1MB_PDRI-MUNDIAL</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Datos y SMS en Roaming Internacional:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="280">
<p><strong>Paquete de Datos en Roaming Internacional</strong></p>
</td>
<td width="149">
<p><strong>Paquete de 1 MB</strong></p>
</td>
<td width="222">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="149">
<p>2.00 MXN</p>
</td>
<td width="222">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="149">
<p>1.72 MXN</p>
</td>
<td width="222">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="280">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="149">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="222">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="280">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="149">
<p>30 d&iacute;as, o una fecha inicio una fecha fin</p>
<p>entre las que transcurre un mes natural</p>
</td>
<td width="222">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>Cuota de Datos (MB / Usuario Final / Ciclo</strong></p>
<p><strong>Individual)</strong></p>
</td>
<td width="149">
<p>1</p>
</td>
<td width="222">
<p>Aplica para consumo de Datos en los</p>
<p>pa&iacute;ses incluidos dentro del paquete.</p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de SMS Entrante (SMS / Usuario Final / Ciclo Individual)</strong></p>
</td>
<td width="149">
<p>&nbsp;</p>
<p>1</p>
</td>
<td width="222">
<p>Aplica para SMS Entrantes con destino a pa&iacute;ses incluidos dentro del paquete.</p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="370">
<p>Regiones Incluidas: Norteam&eacute;rica, Latinoam&eacute;rica, Europa, Asia, &Aacute;frica y Ocean&iacute;a</p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="370">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="370">
<p>Indefinido.</p>
</td>
</tr>
<tr>
<td width="280">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="370">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h3>ANEXO 0920-100U_PVSMSRI</h3>
<p>El presente anexo describe el detalle de condiciones aplicables para los Paquetes de Voz y SMS en Roaming Internacional:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="216">
<p><strong>Paquete de Voz y SMS para Roaming Internacional</strong></p>
</td>
<td width="176">
<p><strong>Paquete de 100 Unidades de Voz y SMS</strong></p>
</td>
<td width="258">
<p><strong>Condiciones de aplicaci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (con IVA)</strong></p>
</td>
<td width="176">
<p>399.00 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Precio de Referencia (sin IVA)</strong></p>
</td>
<td width="176">
<p>343.97 MXN</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Margen Porcentual Fijo</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>20%</p>
</td>
<td width="258">
<p>El Margen Porcentual Fijo depender&aacute; del porcentaje de Consumo Fuera de Huella Alt&aacute;n que se realice en cada Producto (de acuerdo a lo se&ntilde;alado en la Tabla 7 de este Ap&eacute;ndice).</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Ciclo Individual</strong></p>
</td>
<td width="176">
<p>30 d&iacute;as, o una fecha inicio una fecha fin entre las que transcurre un mes natural</p>
</td>
<td width="258">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="216">
<p>&nbsp;</p>
<p><strong>Unidades Incluidas (Paquetes / Ciclo Individual)</strong></p>
</td>
<td width="176">
<p>&nbsp;</p>
<p>100 minutos y 100 SMS</p>
</td>
<td width="258">
<p>Las unidades incluidas en el paquete de Voz y SMS incluyen:</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz Saliente con origen en una red dentro de los pa&iacute;ses incluidos en el Producto y destino a una red en M&eacute;xico;</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Voz entrante en Roaming Internacional en una red dentro de los pa&iacute;ses incluidos en el Producto; y</p>
<p>-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; SMS Salientes con destino a M&eacute;xico.</p>
<p>Los SMS entrantes no se descontar&aacute;n de los eventos de la bolsa.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Pa&iacute;ses incluidos</strong></p>
</td>
<td colspan="2" width="434">
<p>Norteam&eacute;rica, Latinoam&eacute;rica (excl. Caribe), Europa y Asia.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Comercializaci&oacute;n</strong></p>
</td>
<td colspan="2" width="434">
<p>Hasta el 31 de diciembre de 2021.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Periodo de Validez</strong></p>
</td>
<td colspan="2" width="434">
<p>No est&aacute; disponible en renovaci&oacute;n de Ciclo Individual. Deber&aacute; ser contratado a demanda.</p>
</td>
</tr>
<tr>
<td width="216">
<p><strong>Redes Sociales Incluidas</strong></p>
</td>
<td colspan="2" width="434">
<p>No Aplica.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h4><u>Condiciones generales de uso para Datos incluidos en el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de</u> <u>Redes Sociales &ldquo;RRSS&rdquo;</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>Whatsapp&reg;</strong></p>
<ol>
<li><strong><u>Incluye</u></strong>: env&iacute;o de mensajes de texto; env&iacute;o de notas de voz; env&iacute;o de fotos, videos y archivos; descargar o guardar fotos y videos; env&iacute;o de contactos de la agenda; recibir notificaciones desde la aplicaci&oacute;n; compartir una ubicaci&oacute;n propia; y consultar ubicaci&oacute;n de cualquier</li>
<li><strong><u>No Incluye</u></strong>: la carga y descarga de fotos fuera de la aplicaci&oacute;n oficial; compartir, reproducir, cargar o descargar videos a trav&eacute;s de aplicaciones distintas a la oficial; el redireccionamiento a cualquier link o URL externo a la aplicaci&oacute;n oficial; el servicio de llamadas de voz y video llamadas; la transmisi&oacute;n de video en tiempo real; la reproducci&oacute;n de video en tiempo real; compartir ubicaci&oacute;n propia o seguir una ubicaci&oacute;n en tiempo real; y cualquier otra funcionalidad que no est&eacute; enlistada como</li>
</ol>
<p>&nbsp;</p>
<h4>Facebook&reg;/Messenger&reg;</h4>
<ol>
<li><strong><u>Incluye</u></strong>: visualizaci&oacute;n del muro personal o de cualquier otra persona o grupo; publicaci&oacute;n estado personal o el de cualquier otro usuario; publicaci&oacute;n de fotos y videos en el muro utilizando las aplicaciones oficiales; guardar fotos del muro personal o compartidas por cualquier grupo o usuario; dar &ldquo;me gusta&rdquo; a alguna historia personal, de un grupo o un usuario; env&iacute;o de mensajes de texto a trav&eacute;s de Messenger&reg;; compartir im&aacute;genes a trav&eacute;s de Messenger&reg;; recibir notificaciones a trav&eacute;s de las aplicaciones oficiales de Facebook&reg;; y consultar la ubicaci&oacute;n de cualquier</li>
<li><strong><u>No Incluye</u></strong>: la carga y descarga de fotos a trav&eacute;s de aplicaciones distintas de las oficiales; la reproducci&oacute;n de videos y la funcionalidad para compartirlos desde la aplicaci&oacute;n de Facebook&reg; o utilizando otras aplicaciones; el redireccionamiento a cualquier link o URL externo a la aplicaci&oacute;n, aun cuando este haya sido compartido utiliz&aacute;ndola a trav&eacute;s de alg&uacute;n estado o mensaje directo; el servicio de llamadas de voz y video llamadas; la transmisi&oacute;n de video en tiempo real; la reproducci&oacute;n de video en tiempo real; compartir una ubicaci&oacute;n, propia en vivo o seguir ubicaci&oacute;n de cualquier contacto en vivo; y cualquier otra funcionalidad no enlistada como</li>
</ol>
<p>&nbsp;</p>
<h4>Instagram&reg;</h4>
<ol>
<li><strong><u>Incluye</u></strong>: visualizar la l&iacute;nea de tiempo personal o de terceros; publicar una foto o video; comentar sobre un foto o video; enviar y recibir mensajes de texto a trav&eacute;s del buz&oacute;n (&ldquo;Direct&rdquo;); enviar y recibir fotos o videos a trav&eacute;s del buz&oacute;n (&ldquo;Direct&rdquo;); y publicar y reproducir historias (&ldquo;Stories&rdquo;).</li>
<li><strong><u>No Incluye</u></strong>: la carga y descarga de fotos o videos fuera de la aplicaci&oacute;n, a&uacute;n y cuando estos hayan sido compartidos a trav&eacute;s de la misma; compartir fotos o videos a trav&eacute;s de otras aplicaciones distintas a &ldquo;Instagram&rdquo; a&uacute;n y cuando estos se hayan compartido a trav&eacute;s de la aplicaci&oacute;n; la transmisi&oacute;n de video en tiempo real (&ldquo;Live Video Streaming&rdquo;); la reproducci&oacute;n</li>
</ol>
<p>&nbsp;</p>
<p>de video en tiempo real (&ldquo;Live Video Streaming&rdquo;) a manera de espectador; el redireccionamiento a cualquier link o URL externo a la aplicaci&oacute;n, aun cuando este haya sido compartido utiliz&aacute;ndola a trav&eacute;s de un mensaje, publicaci&oacute;n, historia o video en tiempo real; y cualquier otra funcionalidad no enlistada como incluida.</p>
<p>&nbsp;</p>
<h4>Snapchat&reg;</h4>
<ol>
<li><strong><u>Incluye</u></strong>: visualizar &ldquo;Snaps&rdquo; personales y/o de terceros; publicar un &ldquo;Snap&rdquo;; comentar un &ldquo;Snap&rdquo;, enviar y recibir mensajes de texto a trav&eacute;s del buz&oacute;n (&ldquo;Chat&rdquo;); enviar y recibir fotos o video a trav&eacute;s del buz&oacute;n (&ldquo;Chat&rdquo;); y reproducir &ldquo;Historias&rdquo; o &ldquo;Memorias&rdquo;.</li>
<li><strong><u>No Incluye</u></strong>: la carga y descarga de fotos o videos fuera de la aplicaci&oacute;n, a&uacute;n y cuando estos hayan sido compartidos a trav&eacute;s de la misma; compartir fotos o videos a trav&eacute;s de otras aplicaciones distintas a &ldquo;Snapchat&rdquo; a&uacute;n y cuando estos se hayan compartido a trav&eacute;s de la aplicaci&oacute;n; la transmisi&oacute;n de video en tiempo real (&ldquo;Live Video Streaming&rdquo;); la reproducci&oacute;n de video en tiempo real (&ldquo;Live Video Streaming&rdquo;) a manera de espectador; el redireccionamiento a cualquier link o URL externo a la aplicaci&oacute;n, a&uacute;n cuando este haya sido compartido utiliz&aacute;ndola a trav&eacute;s de un mensaje, publicaci&oacute;n, historia o video en tiempo real; y cualquier otra funcionalidad no enlistada como</li>
</ol>
<p>&nbsp;</p>
<h4>Twitter&reg;</h4>
<ol>
<li><strong><u>Incluye</u></strong>: visualizar la l&iacute;nea de tiempo personal o de terceros; publicar un tuit; comentar sobre un tuit; dar &ldquo;me gusta&rdquo; a un tuit; retuitear un tuit; citar un tuit; env&iacute;o de mensaje directo; recepci&oacute;n de notificaciones; publicaci&oacute;n o cargue de fotos en la l&iacute;nea de tiempo; descargar fotos; y compartir ubicaci&oacute;n.</li>
<li><strong><u>No Incluye</u></strong>: la carga y descarga de fotos en aplicaciones distintas a la oficial; la reproducci&oacute;n de videos y la funcionalidad para compartirlos, desde la aplicaci&oacute;n de Twitter&reg; o utilizando otras aplicaciones; el redireccionamiento a cualquier link o URL externo a la aplicaci&oacute;n, aun cuando este haya sido compartido utiliz&aacute;ndola a trav&eacute;s de la l&iacute;nea de tiempo o mensaje directo; la transmisi&oacute;n de video en tiempo real; la reproducci&oacute;n de video en tiempo real; compartir una ubicaci&oacute;n, propia en vivo o seguir ubicaci&oacute;n de cualquier contacto en vivo; y cualquier otra funcionalidad no enlistada como</li>
</ol>
<p>&nbsp;</p>
<h4>Uber&reg;</h4>
<ol>
<li><strong><u>Incluye</u></strong>: ingresar a la aplicaci&oacute;n y solicitar un servicio de transporte; seguir el trayecto del conductor que va en camino a recoger al usuario del servicio y hasta que llegue a su destino final; consultar y actualizar los m&eacute;todos de pago; consultar el hist&oacute;rico de viajes realizados, as&iacute; como, promociones vigentes que se encuentren almacenadas dentro de la aplicaci&oacute;n; Env&iacute;o de mensajes de texto entre el usuario y conductor desde la aplicaci&oacute;n; creaci&oacute;n de perfiles familiares; calificaci&oacute;n del servicio. Lo anterior aplica tanto para los usuarios como para los conductores y en las aplicaciones de Uber, Uber Lite y Uber</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><strong><u>No Incluye</u></strong>: Descargar la aplicaci&oacute;n UBER; cualquier contenido (imagen, audio, video o audio y video asociado) almacenado fuera de la aplicaci&oacute;n UBER&reg;, a&uacute;n y cuando &eacute;ste haya sido consultado a trav&eacute;s de la aplicaci&oacute;n. Por ejemplo: listas de reproducci&oacute;n de m&uacute;sica (Spotify, Deezer, Pandora etc.), contenidos de otras redes sociales no incluidas las Redes Sociales del Producto contratado, y las llamadas realizadas al conductor o al usuario marcando desde la aplicaci&oacute;n; env&iacute;o de c&oacute;digo promocional generado por la aplicaci&oacute;n hacia otros contactos; cualquier otra funcionalidad no enlistada como incluida. No aplica para el uso de la aplicaci&oacute;n de conductores llamada &ldquo;UBER DRIVE&rdquo;. Lo anterior aplica tanto para los usuarios como para los conductores; cualquier acceso a ligas externas o desde enlaces alternos, llamadas de voz IP o video llamadas realizadas, descarga o carga de archivos, ver o transmitir en vivo, etc., a trav&eacute;s de las redes sociales se contabilizar&aacute; como consumo adicional y se descontar&aacute; de los MB/GB incluidos en el Producto</li>
</ol>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 11.4</p>
<p>&nbsp;</p>
<p>PLAN DE PROYECTO E IMPLEMENTACI&Oacute;N</p>
<p>&nbsp;</p>
<p>MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 11.4 &ldquo;Plan de Proyecto e Implementaci&oacute;n MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN</p>
<p>PORCENTUAL FIJO &rdquo; al que se refiere el Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo; del</p>
<p>Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021.&nbsp; Los&nbsp; t&eacute;rminos&nbsp; con&nbsp; inicial&nbsp; may&uacute;scula&nbsp; que&nbsp; se&nbsp; utilizan&nbsp; en&nbsp; el&nbsp; presente&nbsp;&nbsp; Ap&eacute;ndice tienen el significado que se les atribuye en el Contrato&nbsp; o&nbsp; en&nbsp; el&nbsp; propio&nbsp; Anexo&nbsp;&nbsp;&nbsp;&nbsp; 11&nbsp;&nbsp;&nbsp;&nbsp; &ldquo;Servicios&nbsp;&nbsp;&nbsp; MOVILIDAD&nbsp;&nbsp;&nbsp; SIM&nbsp;&nbsp;&nbsp; ALT&Aacute;N:&nbsp;&nbsp;&nbsp; GRANEL&nbsp;&nbsp;&nbsp; Y &nbsp;PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Objeto</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Este Ap&eacute;ndice tiene como objeto establecer el Plan de Proyecto&nbsp; acordado entre las Partes para logar la integraci&oacute;n y Puesta&nbsp; en&nbsp; Marcha&nbsp; del&nbsp; Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS&nbsp; CON MARGEN PORCENTUAL FIJO .</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En la siguiente tabla se describe el Plan de Proyecto, incluyendo las responsabilidades, los requerimientos, actividades, pruebas de los Servicios MOVILIDAD SIM ALT&Aacute;N:&nbsp;&nbsp; GRANEL&nbsp;&nbsp;&nbsp; Y&nbsp;&nbsp;&nbsp; PRODUCTOS&nbsp;&nbsp;&nbsp; EMPAQUETADOS&nbsp;&nbsp;&nbsp; CON MARGEN PORCENTUAL FIJO, dependencias de terceros y los tiempos</li>
</ul>
<ul>
<li>El Plan de Proyecto tendr&aacute; los siguientes hitos:</li>
</ul>
<ul>
<li>Aceptaci&oacute;n del documento <em>Low Level Design </em>(LLD). Fecha: 15 de octubre de</li>
</ul>
<ul>
<li>Establecimiento de la primera sesi&oacute;n de datos de los Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO . Fecha: 29 de octubre de</li>
<li>Puesta en Marcha del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO . Fecha: 8 de noviembre de</li>
</ul>
<ul>
<li>Las Partes deber&aacute;n cumplir, en los tiempos establecidos, con cada una de las obligaciones a su cargo establecidas bajo el Plan de</li>
</ul>
<ul>
<li>El &oacute;rgano encargado del seguimiento y cumplimiento del Plan de Proyecto es el Comit&eacute; de Puesta en Marcha, en t&eacute;rminos de lo establecido en el Anexo 2 &ldquo;Procedimientos Operativos&rdquo; del</li>
</ul>
<ul>
<li>En caso de que alguna de las Partes identifique alguna dificultad o demora durante la ejecuci&oacute;n del Plan de Proyecto, dicha Parte deber&aacute; reportarla, informando de manera justificada el detalle de la dificultad o problema que pueda causar la demora al Comit&eacute; de Puesta en Marcha, para que, en su caso, se tomen las medidas necesarias para asegurar que se cumpla la Puesta en Marcha del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO en la fecha prevista.</li>
</ul>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de&nbsp; diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 11.5</p>
<p>ACUERDO DE NIVEL DE SERVICIOS Y GESTI&Oacute;N DE INCIDENCIAS MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN</p>
<p>PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 11.5 &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias&rdquo; al que se refiere el Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; del &nbsp;Contrato</p>
<p>Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las&nbsp; Partes&nbsp; el&nbsp; 7&nbsp; de&nbsp; diciembre&nbsp; de&nbsp; 2021.&nbsp; Los&nbsp; t&eacute;rminos&nbsp; con&nbsp; inicial&nbsp; may&uacute;scula&nbsp; que&nbsp; se&nbsp; utilizan&nbsp; en&nbsp; el&nbsp; presente&nbsp;&nbsp; Ap&eacute;ndice tienen el significado que se les atribuye en el Contrato o en el propio Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON</p>
<p>MARGEN PORCENTUAL FIJO&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Introducci&oacute;n</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El presente&nbsp; Ap&eacute;ndice&nbsp;&nbsp; establece&nbsp;&nbsp; los&nbsp;&nbsp; procedimientos&nbsp;&nbsp; para&nbsp;&nbsp; la&nbsp;&nbsp; gesti&oacute;n&nbsp;&nbsp; de incidencias y los factores que pueden influir en la calidad del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO, as&iacute; como los par&aacute;metros y niveles objetivos de calidad que integran el Acuerdo de Nivel de Servicios</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los indicadores de calidad y de gesti&oacute;n de incidencias incluidos en la Cl&aacute;usula Segunda y el apartado 5.4 de este Ap&eacute;ndice, respectivamente,&nbsp; s&oacute;lo&nbsp; son&nbsp; de&nbsp; aplicaci&oacute;n para el &aacute;rea de Cobertura de la Red</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Para los efectos del presente Ap&eacute;ndice, se considera como incidencia todo aquel evento o problema que impida la prestaci&oacute;n del Servicio de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO de Alt&aacute;n al Cliente conforme a sus especificaciones o a el Acuerdo de Nivel de Servicio</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n proveer&aacute; el Servicio de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO de forma no discriminatoria, con la misma calidad y en igualdad&nbsp; de&nbsp; condiciones&nbsp; con&nbsp; la&nbsp; que&nbsp; presta Servicios iguales a otros</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Indicadores de Calidad</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Indicadores de Calidad de la Red</li>
</ul>
<p>&nbsp;</p>
<p>Para los Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO, Alt&aacute;n estar&aacute; obligada a cumplir con los siguientes indicadores de calidad, de acuerdo con lo establecido&nbsp; en&nbsp; el&nbsp; Contrato de APP:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="180">
<p>&nbsp;</p>
<p><strong>Indicador</strong></p>
</td>
<td width="350">
<p>&nbsp;</p>
<p><strong>Medici&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="180">
<p>&nbsp;</p>
<p>Tasa de Transmisi&oacute;n de Datos del Enlace Descendente</p>
</td>
<td width="350">
<p>&nbsp;</p>
<p>Cantidad promedio de Datos descargada con respecto a 1 (un) segundo y que deber&aacute; ser de al menos 4 (cuatro) Megabits por segundo en el borde de Cobertura exterior (no en inmuebles) en Hora Pico de la Red Compartida</p>
</td>
</tr>
<tr>
<td width="180">
<p>&nbsp;</p>
<p>Tasa de Transmisi&oacute;n de Datos del Enlace Ascendente</p>
</td>
<td width="350">
<p>&nbsp;</p>
<p>Cantidad promedio de Datos enviada con respecto a 1 (un) segundo y que deber&aacute; ser de al menos 1 (un) Megabit por segundo en el borde de Cobertura en Hora Pico de la Red Compartida exterior (no en inmuebles)</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>Alt&aacute;n deber&aacute; cumplir con los par&aacute;metros de Calidad establecidos en las disposiciones contenidas en los Lineamientos que fijan los &iacute;ndices y par&aacute;metros de calidad a que deber&aacute;n sujetarse los prestadores del Servicio m&oacute;vil aprobado mediante acuerdo P/IFT/161117/715, o cualquier disposici&oacute;n que los modifique o sustituya.</p>
<p>&nbsp;</p>
<ul>
<li>Asimismo, Alt&aacute;n deber&aacute; cumplir con el indicador de calidad de las interfases de Plataforma de Gesti&oacute;n Mayorista:</li>
</ul>
<p>&nbsp;</p>
<ol start="11">
<li>El indicador de calidad de las interfases de Plataforma de Gesti&oacute;n Mayorista de Alt&aacute;n es el porcentaje de tiempo en que todos sus componentes se encuentran disponibles (seg&uacute;n se especifica en el Ap&eacute;ndice 11.1 &ldquo;Alcance T&eacute;cnico MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;) y se calcular&aacute; conforme a la siguiente f&oacute;rmula:</li>
</ol>
<p>&nbsp;</p>
<p>% de disponibilidad = se calcula restando de 1 (uno) el siguiente cociente: suma de todos los eventos (entendiendo como un evento una interrupci&oacute;n del Servicio superior a 10 (diez) segundos consecutivos medidos en segundos incurridos en 1 (un) mes) dividido por el total de segundos de 1 (un) mes (2,592,000).</p>
<p>&nbsp;</p>
<ol>
<li>El tiempo de indisponibilidad inicia desde el momento en que sea confirmada por el Centro de Operaciones (NOC). Al respecto, no se considerar&aacute;n como causales de indisponibilidad atribuibles a Alt&aacute;n y, por lo tanto, no est&aacute;n sujetas a los indicadores de calidad del Servicio, las siguientes:</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Las fallas producidas en equipos y componentes diferentes a los suministrados por Alt&aacute;n.</li>
<li>Fallas imputables al Cliente en los elementos o plataformas de los que el Cliente es</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>La indisponibilidad debida a todas las labores de mantenimiento preventivo y a las labores de mantenimiento correctivo ocasionadas por hechos o actos no atribuibles a Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Alt&aacute;n estar&aacute; obligada a la siguiente disponibilidad para el Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="265">
<p>&nbsp;</p>
<p><strong>Indicador</strong></p>
</td>
<td width="216">
<p><strong>Compromiso de Disponibilidad del Servicio</strong></p>
</td>
</tr>
<tr>
<td width="265">
<p>Disponibilidad de las interfases de la Plataforma de Gesti&oacute;n Mayorista</p>
</td>
<td width="216">
<p>99.5%</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<h4><u>TERCERA.&nbsp;&nbsp;&nbsp; Penalizaciones</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En caso de que para un determinado mes calendario la disponibilidad del servicio de gesti&oacute;n mayorista est&eacute; por debajo del valor definido en la tabla del apartado 2, inciso</li>
</ul>
<ol>
<li>c) anterior, se aplicar&aacute; una penalizaci&oacute;n que ser&aacute; resultante de aplicar el porcentaje de diferencia entre el compromiso de disponibilidad del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO y la disponibilidad mensual, multiplicado por la cantidad monetaria, antes de impuestos, de la &uacute;ltima factura mensual emitida por parte de Alt&aacute;n al</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>En caso de: (i) sanciones impuestas por la Procuradur&iacute;a Federal del Consumidor (en adelante &ldquo;<strong>PROFECO</strong>&rdquo;) al Cliente como resultado de una reclamaci&oacute;n de un Usuario Final en lo individual o de una reclamaci&oacute;n colectiva de un grupo de Usuarios Finales; (ii) sanciones impuestas por un tribunal civil competente al Cliente como resultado de una reclamaci&oacute;n de un Usuario Final en lo individual o de una acci&oacute;n colectiva de un grupo de Usuarios Finales; o (iii) sanciones impuestas por PROFECO al Cliente como resultado de una actuaci&oacute;n de oficio originada por fallas generalizadas o masivas; por una causa exclusiva y directamente imputable a Alt&aacute;n, siempre que haya sido acreditada fehacientemente por el Cliente, se proceder&aacute; de acuerdo con lo que se establece en esta Cl&aacute;usula.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n pagar&aacute; al Cliente las sanciones correspondientes a que hace alusi&oacute;n el p&aacute;rrafo anterior, siempre y cuando el Cliente acredite con la Resoluci&oacute;n por parte de la autoridad competente que: (i) la falla en el Servicio que ocasion&oacute; la sanci&oacute;n por parte de PROFECO o el tribunal civil competente haya sido atribuible exclusivamente a Alt&aacute;n; (ii) el(los) Usuario(s) Final(es) respectivo(s) haya(n) presentado una reclamaci&oacute;n individual o colectiva en contra del Cliente ante PROFECO o un tribunal civil competente y se haya llevado a cabo y concluido un proceso de conciliaci&oacute;n con los Usuarios Finales afectados sin lograr eliminar la sanci&oacute;n, o que PROFECO haya impuesto de oficio al Cliente la obligaci&oacute;n de realizar una compensaci&oacute;n por una falla generalizada o masiva atribuible exclusivamente a Alt&aacute;n y que la misma haya sido debidamente acreditada mediante un resoluci&oacute;n con la fundamentaci&oacute;n y motivaci&oacute;n necesaria de acuerdo con la Ley Aplicable;</p>
<p>(iii) realiz&oacute; el pago de la sanci&oacute;n o compensaci&oacute;n a el(los) Usuario(s) Final(es) respectivo(s); y (iv) la falla no se debi&oacute;, directa o indirectamente, a un evento de Fuerza Mayor.</p>
<p>&nbsp;</p>
<p>La compensaci&oacute;n a pagar por Alt&aacute;n al Cliente con motivo de la sanci&oacute;n impuesta al Cliente conforme a la presente cl&aacute;usula estar&aacute; siempre limitada: (i) en caso de una sanci&oacute;n impuesta por PROFECO o un tribunal civil competente al Cliente derivado de una reclamaci&oacute;n de un Usuario Final individual, a la parte proporcional del precio pagado por el Cliente a Alt&aacute;n por el Servicio en el que ocurra la falla respecto al Usuario Final que presente la reclamaci&oacute;n correspondiente por el tiempo y/o periodo que se dej&oacute; de prestar el Servicio m&aacute;s el 20% (veinte por ciento) del monto del periodo de afectaci&oacute;n; o (ii) en caso de una compensaci&oacute;n impuesta de oficio por PROFECO al Cliente por una falla generalizada o masiva, de una sanci&oacute;n impuesta por PROFECO mediante la resoluci&oacute;n de una reclamaci&oacute;n colectiva o de una sanci&oacute;n impuesta por un tribunal civil competente mediante la sentencia que ponga fin a una acci&oacute;n colectiva, a la suma de las penalizaciones determinadas conforme al inciso (i) anterior respecto a los Usuarios Finales efectivamente afectados por la falla del Servicio correspondiente.</p>
<p>&nbsp;</p>
<p>En caso de que una de las Partes as&iacute; lo requiera, las Partes deber&aacute;n reunirse para analizar la posibilidad de impugnar la sanci&oacute;n impuesta por PROFECO o por el tribunal civil competente al Cliente. En caso de que Alt&aacute;n decida que procede interponer alg&uacute;n medio de defensa, impugnaci&oacute;n o acci&oacute;n al respecto, el pago de la sanci&oacute;n quedar&aacute; suspendido hasta que se resuelva de manera firme e inapelable el medio de defensa, impugnaci&oacute;n o acci&oacute;n respectivo o hasta que Alt&aacute;n decida que procede desistirse del mismo o transigir con la contraparte. Alt&aacute;n deber&aacute; cubrir los costos del asesoramiento legal que eventualmente se requiera de despachos de abogados externos, siempre y cuando los mismos hayan sido aprobados previamente y por escrito por Alt&aacute;n, as&iacute; como los gastos y costas de juicio que sean determinados por la autoridad administrativa o judicial competente. Ambas Partes colaborar&aacute;n de buena fe y har&aacute;n sus mejores esfuerzos para conseguir el resultado m&aacute;s beneficioso y minimizar los costos asociados a la eventual sanci&oacute;n y a la defensa legal, haci&eacute;ndose cargo cada una de las Partes de los costos de sus recursos internos dedicados a tal fin.</p>
<p>&nbsp;</p>
<p>PROFECO, ante la presencia de fallas generalizadas o notorias en la prestaci&oacute;n de servicios a los Usuarios Finales, puede establecer y/o proponer a los prestadores de servicios de telecomunicaciones como el Cliente, el implementar medidas compensatorias a los Usuarios Finales (en adelante las &ldquo;<strong>Medidas Compensatorias</strong>&rdquo;). Las Medidas Compensatorias, regularmente son implementadas por los diferentes prestadores de servicios de telecomunicaciones en atenci&oacute;n a la solicitud de PROFECO para evitar la imposici&oacute;n de sanciones y en beneficio de los Usuarios Finales y para evitar quejas o reclamaciones formales de los mismos, ya sean individuales o colectivas. Considerando lo anterior, las Partes est&aacute;n de acuerdo en que en caso de que la PROFECO solicite al Cliente la implementaci&oacute;n de una Medida Compensatoria como resultado de fallas en los Servicios atribuibles exclusiva y directamente a Alt&aacute;n, las Partes se reunir&aacute;n para revisar de manera conjunta y de buena fe dicha Medida Compensatoria a efecto de determinar de com&uacute;n acuerdo la mejor forma de atender a la misma, aplicando siempre los principios establecidos en esta cl&aacute;usula 3.2, y sin que ello implique responsabilidad de naturaleza alguna de Alt&aacute;n frente a PROFECO y/o cualesquier Usuarios Finales.</p>
<p>&nbsp;</p>
<ul>
<li>El monto de las sanciones a pagar por parte de Alt&aacute;n hacia el Cliente, se aplicar&aacute; como una nota de cr&eacute;dito sobre la factura del periodo de facturaci&oacute;n siguiente (antes de impuestos) que Alt&aacute;n emita al Cliente por los Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO. En caso de que se haya determinado como procedente el monto de la sanci&oacute;n impuesta al</li>
</ul>
<p>&nbsp;</p>
<p>Cliente por acausa atribuible exclusivamente a Alt&aacute;n, y que haya sido debidamente acreditada con la Resoluci&oacute;n por parte de la autoridad competente conforme a lo establecido en la Cl&aacute;usula 3.2 anterior y la nota de cr&eacute;dito no haya sido emitida por Alt&aacute;n, el Cliente tendr&aacute; la opci&oacute;n de requerir a Alt&aacute;n el pago de la sanci&oacute;n aplicable, en cuyo caso el pago deber&aacute; ser hecho por Alt&aacute;n dentro de los 30 (treinta) D&iacute;as siguientes a la fecha en que Alt&aacute;n reciba el requerimiento de pago del Cliente.</p>
<p>&nbsp;</p>
<h4><u>CUARTA. Factores que Pueden Afectar la Calidad del Servicio MOVILIDAD SIM</u> <u>ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL</u> <u>FIJO</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Dada la naturaleza de la propagaci&oacute;n inal&aacute;mbrica, la calidad del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO se encuentra relacionada con la naturaleza de la se&ntilde;al de radio, quedando &eacute;sta fuera del alcance y control de Alt&aacute;n en muchas La propagaci&oacute;n de la se&ntilde;al radio depende de los obst&aacute;culos existentes entre la radiobase (eNB) y el equipo terminal del Usuario Final, pudi&eacute;ndose presentar variaciones por desvanecimiento, interferencias y perdidas de cobertura por la presencia de obst&aacute;culos, as&iacute; como de las condiciones climatol&oacute;gicas no favorables (ej. lluvia).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n &uacute;nicamente es responsable de la prestaci&oacute;n de los Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO conforme a lo expresamente establecido en el Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; y sus Ap&eacute;ndices. Cualquier situaci&oacute;n o concepto no contemplado en los instrumentos anteriores no ser&aacute; responsabilidad de Alt&aacute;n, incluyendo los factores externos a Alt&aacute;n que puedan afectar la calidad de los Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La calidad de los Servicios Movilidad SIM ALTAN puede verse afectada por una mayor demanda de tr&aacute;fico o de Usuarios Finales de la originalmente prevista por el Cliente en el Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;. A tal efecto, el Cliente deber&aacute; reportar de manera regular dichas proyecciones de tr&aacute;fico.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Con la finalidad de mantener la integridad de la Red Compartida y no afectar a otro(s) cliente(s), Alt&aacute;n podr&aacute; suspender las activaciones en una determinada regi&oacute;n o localidad, sin responsabilidad alguna para Alt&aacute;n, en caso de que el tr&aacute;fico en dicha regi&oacute;n o localidad incluida en el formulario &ldquo;Proyecciones a 12 meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; mencionado en el Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; exceda las proyecciones realizadas por el Cliente en m&aacute;s del 50% (cincuenta por ciento). La suspensi&oacute;n de las activaciones en dicha regi&oacute;n o localidad se realizar&aacute; 24 (veinticuatro) horas despu&eacute;s de que Alt&aacute;n notifique al Cliente la necesidad de la suspensi&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Dicha suspensi&oacute;n permanecer&aacute; en vigor hasta que: (a) Alt&aacute;n pueda asegurar la integridad de la Red Compartida sin afectar a otros clientes; (b) Alt&aacute;n pueda resolver la carencia de numeraci&oacute;n en la regi&oacute;n o localidad en la que se presente la afectaci&oacute;n; y (c) el Cliente entregue proyecciones corregidas mediante la presentaci&oacute;n de un nuevo formulario</p>
<p>&nbsp;</p>
<p>&ldquo;Proyecciones a 12 meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; conforme a lo establecido en el Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;.</p>
<p>&nbsp;</p>
<h4><u>QUINTA. Gesti&oacute;n de Incidencias</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Incidencias del Cliente.</li>
</ul>
<p>&nbsp;</p>
<p>Se consideran Incidencias del Cliente aquellas que afectan a un Usuario Final o a un conjunto de Usuario Finales del Cliente, las cuales ser&aacute;n clasificadas conforme a lo siguiente:</p>
<p>&nbsp;</p>
<ol>
<li><u>Incidencias Cr&iacute;ticas.</u> Ser&aacute;n incidencias cr&iacute;ticas aquellas que impidan el uso del Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO para todos los Usuarios Finales o un grupo significativo del total de los Usuarios Finales del Cliente. De forma enunciativa, pero no limitativa, las incidencias cr&iacute;ticas incluyen:
<ol>
<li>Ca&iacute;da de elementos de red que brinden servicio masivo (ejemplo SGW, PGW, MME, DRA).</li>
<li>Ca&iacute;da de 25 (veinticinco) o m&aacute;s radiobases (eNB).</li>
</ol>
</li>
</ol>
<ul>
<li>Imposibilidad de Location Update en determinadas &aacute;reas.</li>
</ul>
<ol>
<li>Imposibilidad de realizar nuevas</li>
<li>Imposibilidad de realizar modificaciones en perfiles de Usuarios Finales en el Core de Alt&aacute;n.</li>
<li>Indisponibilidad del Centro de Operaciones (NOC) facilitado por Alt&aacute;n al Cliente por m&aacute;s de 1 (una)</li>
</ol>
<ol>
<li><u>Incidencias </u> Son las incidencias que suponen una degradaci&oacute;n grave en la prestaci&oacute;n normal de los Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO, incluyendo, sin limitar, las siguientes:
<ol>
<li>Indisponibilidad de servicios suplementarios.</li>
<li>Numeraciones de emergencia mal</li>
</ol>
</li>
<li><u>Incidencias Menores.</u> Son aquellas incidencias que:
<ol>
<li>No tienen un impacto directo en el Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO recibido por los Usuarios Finales del Cliente (e.g. disponibilidad de herramienta de cobertura de red).</li>
</ol>
</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Incidencias Reportadas por Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Con el objetivo de mejorar la visibilidad sobre el estado de operaci&oacute;n y disponibilidad de la Red Compartida y evitar en la medida de lo posible que se abran m&uacute;ltiples tickets de incidencias por parte del Cliente, Alt&aacute;n proactivamente informar&aacute; al Cliente las incidencias en la Red</li>
<li>Dentro de dicho reporte se clasificar&aacute; el nivel de criticidad de la incidencia, as&iacute; como la fecha estimada de soluci&oacute;n, en caso de que est&eacute; disponible, realizando notificaciones de actualizaci&oacute;n seg&uacute;n se vaya progresando en la soluci&oacute;n. Una vez solucionada, tambi&eacute;n se reportar&aacute; el cierre de la</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Indicadores de Calidad de la Resoluci&oacute;n de</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Se definen los siguientes indicadores de calidad para la resoluci&oacute;n de incidencias:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="132">
<p><strong>Criticidad</strong></p>
</td>
<td width="208">
<p><strong>Tiempo De Respuesta</strong></p>
</td>
<td width="208">
<p><strong>Tiempo De Resoluci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="132">
<p>CR&Iacute;TICA</p>
</td>
<td width="208">
<p>30 minutos</p>
</td>
<td width="208">
<p>30% en 6 hrs</p>
<p>50% en 8 hrs</p>
<p>90% en 10 hrs</p>
</td>
</tr>
<tr>
<td width="132">
<p>MAYOR</p>
</td>
<td width="208">
<p>2 horas</p>
</td>
<td width="208">
<p>50% en 12 hrs</p>
<p>90% en 24 hrs</p>
</td>
</tr>
<tr>
<td width="132">
<p>MENOR</p>
</td>
<td width="208">
<p>36 horas</p>
</td>
<td width="208">
<p>90% en 48 hrs</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<ol>
<li>El tiempo de resoluci&oacute;n de una incidencia se calcular&aacute; como el tiempo transcurrido entre la apertura del incidente en el Centro de Operaciones (NOC) de Alt&aacute;n y la notificaci&oacute;n al Cliente por parte de Alt&aacute;n, a trav&eacute;s de la herramienta disponible, de la resoluci&oacute;n de la</li>
</ol>
<p>&nbsp;</p>
<p>Para efectos de los tiempos en la reparaci&oacute;n de incidencias, no se contabilizar&aacute;n:</p>
<p>&nbsp;</p>
<ol>
<li>Retrasos motivados por error del Cliente en la apertura de la incidencia, por falta de respuesta del Cliente ante cualquier requerimiento adicional de informaci&oacute;n o por la imposibilidad de comunicaci&oacute;n con Alt&aacute;n con el fin de solucionar la incidencia;</li>
<li>Todos aquellos retrasos injustificados por causa del Cliente; y/o</li>
</ol>
<ul>
<li>Fuerza</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Matriz de</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>A continuaci&oacute;n, se define el siguiente procedimiento de escalaci&oacute;n para la resoluci&oacute;n de las incidencias cr&iacute;ticas:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="84">
<p>&nbsp;</p>
<p><strong>Nivel</strong></p>
</td>
<td width="217">
<p>&nbsp;</p>
<p><strong>Responsable</strong></p>
</td>
<td width="151">
<p>&nbsp;</p>
<p><strong>Contacto</strong></p>
</td>
<td width="123">
<p>&nbsp;</p>
<p><strong>Prioridad</strong></p>
</td>
</tr>
<tr>
<td width="84">
<p>&nbsp;</p>
<p>1</p>
</td>
<td width="217">
<p>&nbsp;</p>
<p>Grupo de Servicio a Cliente</p>
</td>
<td width="151">
<p>&nbsp;</p>
<p>Ser&aacute; comunicado por el Representante Comercial</p>
</td>
<td width="123">
<p>&nbsp;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="84">
<p>&nbsp;</p>
<p>2</p>
</td>
<td width="217">
<p>&nbsp;</p>
<p>Gerente de Servicio a Cliente</p>
</td>
<td width="151">
<p>&nbsp;</p>
<p>Ser&aacute; comunicado por el Representante Comercial</p>
</td>
<td width="123">
<p>&nbsp;</p>
<p>Despu&eacute;s de 1 hora</p>
</td>
</tr>
<tr>
<td width="84">
<p>&nbsp;</p>
<p>3</p>
</td>
<td width="217">
<p>&nbsp;</p>
<p>Subdirector de Servicio a Cliente</p>
</td>
<td width="151">
<p>&nbsp;</p>
<p>Ser&aacute; comunicado por el Representante Comercial</p>
</td>
<td width="123">
<p>&nbsp;</p>
<p>Despu&eacute;s de 2 horas</p>
</td>
</tr>
<tr>
<td width="84">
<p>&nbsp;</p>
<p>4</p>
</td>
<td width="217">
<p>&nbsp;</p>
<p>Director de Servicio a Cliente</p>
</td>
<td width="151">
<p>&nbsp;</p>
<p>Ser&aacute; comunicado por el Representante Comercial</p>
</td>
<td width="123">
<p>&nbsp;</p>
<p>Despu&eacute;s de 4 horas</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 11.6</p>
<p>&nbsp;</p>
<p>PROYECCIONES MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 11.6 &ldquo;Proyecciones MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; al</p>
<p>que se refiere el Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS &nbsp;CON &nbsp;MARGEN &nbsp;PORCENTUAL &nbsp;FIJO&rdquo; &nbsp;del &nbsp;Contrato &nbsp;Marco &nbsp;de</p>
<p>Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices,&nbsp;&nbsp;&nbsp;&nbsp; el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; se les atribuye en el Contrato o en el propio Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N:&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;GRANEL&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Y&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; PRODUCTOS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; EMPAQUETADOS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; CON&nbsp;&nbsp; &nbsp;MARGEN</p>
<p>PORCENTUAL FIJO&rdquo; o este Ap&eacute;ndice,&nbsp; seg&uacute;n&nbsp; corresponda.&nbsp; Para&nbsp; la&nbsp; interpretaci&oacute;n&nbsp; del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Objeto</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Este Ap&eacute;ndice&nbsp; tiene&nbsp; como&nbsp; objeto&nbsp; establecer&nbsp; las&nbsp; proyecciones&nbsp; de&nbsp; tr&aacute;fico&nbsp; y&nbsp; Usuarios Finales acordadas entre Alt&aacute;n y el Cliente para&nbsp; la&nbsp; prestaci&oacute;n&nbsp; de&nbsp; los&nbsp; servicios de conectividad m&oacute;vil sobre la Red Compartida para el Servicio de MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Previsiones de Usuarios Finales y Tr&aacute;fico</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Cliente deber&aacute;, durante toda la vigencia del Anexo 11 &ldquo;Servicios MOVILIDAD SIM&nbsp;&nbsp; ALT&Aacute;N:&nbsp;&nbsp; GRANEL&nbsp;&nbsp;&nbsp; Y&nbsp;&nbsp;&nbsp; PRODUCTOS&nbsp;&nbsp;&nbsp; EMPAQUETADOS&nbsp;&nbsp;&nbsp; CON MARGEN PORCENTUAL FIJO&rdquo;, enviar a Alt&aacute;n y cumplir las previsiones de Usuarios Finales y tr&aacute;fico (volumen de minutos VoLTE/mVoIP, datos y SMS) de conformidad con el procedimiento establecido en la Cl&aacute;usula Tercera del presente Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los servicios de conectividad m&oacute;vil sobre la&nbsp; Red&nbsp; Compartida&nbsp; para&nbsp; el&nbsp; Servicio MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO ser&aacute;n dimensionados con base en las proyecciones de tr&aacute;fico que el Cliente entregue por escrito a Alt&aacute;n,&nbsp; a&nbsp; trav&eacute;s&nbsp; de&nbsp; los&nbsp; medios establecidos para tales</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La siguiente tabla muestra el Plan&nbsp; de&nbsp; Negocio&nbsp; del&nbsp; Cliente,&nbsp; el&nbsp; cual&nbsp; incluye las proyecciones anuales de tr&aacute;fico a nivel agregado del Cliente para los primeros 3 (tres) a&ntilde;os, con base en las cuales se han dimensionado las&nbsp; integraciones mencionadas en el presente Ap&eacute;ndice:</li>
</ul>
<p>&nbsp;</p>
<p>[EL RESTO DE LA P&Aacute;GINA ES DEJADO EN BLANCO INTENCIONALMENTE; SIGUE TABLA 1 PLAN DE NEGOCIO CLIENTE]</p>
<p>&nbsp;</p>
<p>Tabla 1 Plan de Negocio Cliente</p>
<table class="table">
<tbody>
<tr>
<td width="247">
<p><strong>Concepto</strong></p>
</td>
<td width="64">
<p><strong>A&ntilde;o 1</strong></p>
</td>
<td width="64">
<p><strong>A&ntilde;o 2</strong></p>
</td>
<td width="64">
<p><strong>A&ntilde;o 3</strong></p>
</td>
</tr>
<tr>
<td width="247">
<p>Creaci&oacute;n de SIMs (000)</p>
</td>
<td width="64">
<p>N/A</p>
</td>
<td width="64">
<p>N/A</p>
</td>
<td width="64">
<p>N/A</p>
</td>
</tr>
<tr>
<td width="247">
<p>Usuarios Finales (000)</p>
</td>
<td width="64">
<p>3,6</p>
</td>
<td width="64">
<p>7,2</p>
</td>
<td width="64">
<p>10,8</p>
</td>
</tr>
<tr>
<td width="247">
<p>VoLTE/mVoIP (millones minutos)</p>
</td>
<td width="64">
<p>0,36</p>
</td>
<td width="64">
<p>0,72</p>
</td>
<td width="64">
<p>1,08</p>
</td>
</tr>
<tr>
<td width="247">
<p>Datos (GB)</p>
</td>
<td width="64">
<p>1800</p>
</td>
<td width="64">
<p>36000</p>
</td>
<td width="64">
<p>54000</p>
</td>
</tr>
<tr>
<td width="247">
<p>SMS (millones SMS)</p>
</td>
<td width="64">
<p>0,072</p>
</td>
<td width="64">
<p>0,144</p>
</td>
<td width="64">
<p>0,216</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>Donde Creaci&oacute;n de SIMs son el n&uacute;mero de nuevos Usuarios Finales activados durante el a&ntilde;o (en miles), Usuarios Activos son los Usuarios Finales (en miles) del Cliente que hayan hecho un evento de tr&aacute;fico saliente o entrante al menos durante 30 (treinta) d&iacute;as anteriores al &uacute;ltimo d&iacute;a de cada a&ntilde;o de ejecuci&oacute;n y el tr&aacute;fico viene expresado en millones de minutos de VoLTE/VoIP (enviados y terminados), mensajes de SMS (enviados y terminados y en GB para los Datos.</p>
<p>&nbsp;</p>
<h4><u>TERCERA. Proyecciones iniciales y actualizaci&oacute;n de proyecciones</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Durante la vigencia del Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo;, el Cliente deber&aacute; enviar a Alt&aacute;n el formulario &ldquo;Proyecciones a 12 meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; por los medios establecidos para tales efectos. Este formulario contiene las proyecciones de tr&aacute;fico y Usuarios Finales del Plan de Negocios del Cliente con detalle mensual de, al menos, los siguientes 4 (cuatro) trimestres. Dicho formato ser&aacute; proporcionado por Alt&aacute;n al</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El llenado de la informaci&oacute;n que debe incluirse en el formulario &ldquo;Proyecciones a 12 meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; se realizar&aacute; de manera peri&oacute;dica cada 3 (tres) meses, iniciando a partir de la firma del presente Ap&eacute;ndice. A tal efecto, el Cliente se compromete a enviar el primer formulario de &ldquo;Proyecciones a 12 meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; dentro de un plazo de 11 (diez) D&iacute;as contados a partir de la fecha de firma del presente Ap&eacute;ndice (<u>Proyecciones iniciales</u>). A partir de ese momento, el Cliente deber&aacute; actualizar trimestralmente el formulario de &ldquo;Proyecciones a 12 meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; (<u>Actualizaci&oacute;n de Proyecciones</u>).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Una vez presentado el formulario de &ldquo;Proyecciones a 12 meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO&rdquo; para un determinado trimestre, las proyecciones detalladas en el mismo se considerar&aacute;n definitivas y por tanto no podr&aacute;n modificarse y formar&aacute;n parte del presente Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<h4><u>CUARTA. Variaci&oacute;n de Tr&aacute;fico Real en Comparaci&oacute;n con las Proyecciones</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </strong>En caso de que exista variaciones entre el tr&aacute;fico real en comparaci&oacute;n con las proyecciones establecidas en este Ap&eacute;ndice y en los formularios de &ldquo;Proyecciones a 12</p>
<p>&nbsp;</p>
<p>meses MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON</p>
<p>MARGEN PORCENTUAL FIJO&rdquo; antes mencionados, Alt&aacute;n podr&aacute; tomar las medidas que se establecen en el Ap&eacute;ndice 11.5 &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias&rdquo;.</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 11.7</p>
<p>&nbsp;</p>
<p>ALCANCE DE PRESTACI&Oacute;N DE SERVICIOS DE COADYUVANCIA PARA LA COLABORACI&Oacute;N CON LAS INSTANCIAS DE SEGURIDAD, PROCURACI&Oacute;N Y ADMINISTRACI&Oacute;N DE JUSTICIA</p>
<p>&nbsp;</p>
<p>MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 11.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia&rdquo; al que se refiere el Anexo 11 &ldquo;Servicio de MOVILIDAD SIM ALT&Aacute;N:&nbsp; GRANEL&nbsp; Y&nbsp; PRODUCTOS&nbsp; EMPAQUETADOS&nbsp; CON&nbsp; MARGEN PORCENTUAL</p>
<p>FIJO&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;Contrato&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan&nbsp; en&nbsp; el&nbsp; presente&nbsp; Ap&eacute;ndice&nbsp; tienen el significado que se les atribuye en el Contrato o en&nbsp; el&nbsp; propio&nbsp; Anexo&nbsp; 11&nbsp; &ldquo;Servicio&nbsp;&nbsp; de&nbsp;&nbsp; MOVILIDAD&nbsp; SIM&nbsp; ALT&Aacute;N:&nbsp; GRANEL&nbsp; Y&nbsp; PRODUCTOS EMPAQUETADOS</p>
<p>CON MARGEN PORCENTUAL FIJO&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Fundamentos.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Elons cEusmtapdloims iUenntiodocsonMleoxidciasnpouse;s1to89poyr 1lo9s0 adret&iacute;claulLoesy1F6ederlaal CdeonTsetlietuccoi&oacute;mnunPiocla&iacute;tcicioandees y Radiodifusi&oacute;n (&ldquo;<strong>LFTyR</strong>&rdquo;); 8, 16, 17, 18, 19, 26 y 27 de la Ley Federal Contra la Delincuencia; 177 y 178 bis del C&oacute;digo Penal Federal; 291, 292, 293, 294, 296, 301, 302 y 303, del C&oacute;digo Nacional de Procedimientos Penales (&ldquo;<strong>CNPP</strong>&rdquo;), publicado en el Diario Oficial de la Federaci&oacute;n (&ldquo;<strong>DOF</strong>&rdquo;) el 17 de junio de 2016, cuya &uacute;ltima modificaci&oacute;n fue publicada en el DOF el 8 de noviembre de 2019.; los Lineamientos de Colaboraci&oacute;n en Materia de Seguridad y Justicia (&ldquo;<strong>LCMSJ</strong>&rdquo;), expedidos por el Instituto Federal de Telecomunicaciones (&ldquo;<strong>IFT</strong>&rdquo;) y publicados en el DOF el 2 de diciembre de 2015, as&iacute; como sus respectivas modificaciones de fechas 28 de diciembre de 2017 y 2 de abril de 2018; as&iacute; como el art&iacute;culo 18, fracci&oacute;n XVIII de los Lineamientos para la Comercializaci&oacute;n de Servicios M&oacute;viles por parte de Operadores M&oacute;viles Virtuales (&ldquo;<strong>Lineamientos OMV</strong>&rdquo;), publicado en el DOF el 9 de marzo de 2016, y; de conformidad con el &ldquo;Acuerdo mediante el cual el Pleno del Instituto Federal de Telecomunicaciones emite respuesta a la Solicitud de Confirmaci&oacute;n de Criterio presentada por Alt&aacute;n Redes, A.P.I. de C.V. (en adelante &ldquo;<strong>Alt&aacute;n</strong>&rdquo;), respecto al alcance de aplicaci&oacute;n de los Lineamientos de Colaboraci&oacute;n en Materia de Seguridad y Justicia&rdquo; de fecha 22 de mayo de 2019, para cualquier Operador de Servicios de Telecomunicaciones, Concesionarios y Autorizados es obligatorio colaborar con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia, para lo cual se emite este Ap&eacute;ndice 11.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia&rdquo; (&ldquo;<strong>Acuerdo</strong>&rdquo;).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los efectos y la validez de este Ap&eacute;ndice est&aacute;n sujetos a la condici&oacute;n de que el IFT lo apruebe como parte de la Oferta de Referencia conforme a la Condici&oacute;n 12 de la Concesi&oacute;n de Alt&aacute;n, por lo que la respuesta negativa o el requerimiento de ajustes</li>
</ul>
<p>&nbsp;</p>
<p>por parte del IFT ante la solicitud de Alt&aacute;n no podr&aacute; considerarse incumplimiento o atribuirse a la falta o negligencia de cualquiera de las Partes, quienes quedar&aacute;n obligadas a realizar cualesquier ajustes requeridos por el IFT, en su caso.</p>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Objeto.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El objeto del presente Acuerdo es describir la coadyuvancia que ofrece Alt&aacute;n al &ldquo;<strong>Cliente</strong>&rdquo;, con la finalidad de establecer las obligaciones, responsabilidades y alcances que cada una de las partes deber&aacute; asumir para que puedan dar cumplimiento oportuno a las obligaciones en materia de colaboraci&oacute;n con la seguridad y justicia, que se desprende de la LFTyR y los LCMSJ, relacionadas con la atenci&oacute;n de alg&uacute;n requerimiento de <em>(i) </em>Datos Conservados (&ldquo;<strong>DC</strong>&rdquo;), <em>(ii) </em>Geolocalizaci&oacute;n (&ldquo;<strong>GL</strong>&rdquo;), e; <em>(iii) </em>Intervenci&oacute;n Legal de Comunicaciones (&ldquo;<strong>IL</strong>&rdquo;) por parte de una Autoridad Facultada o</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Asimismo, se identifican los responsables directos e indirectos en cada servicio, as&iacute; como el proceso y tiempos de respuesta, detallando tambi&eacute;n la secuencia l&oacute;gica del procedimiento que deber&aacute; seguirse para poder dar respuesta oportuna a los requerimientos de informaci&oacute;n provenientes de las Autoridades Facultadas y Designadas.</li>
</ul>
<p>&nbsp;</p>
<h4><u>TERCERA. Definiciones.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Las siguientes definiciones aplican de forma general al presente Ap&eacute;ndice:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>"<strong>Autoridades Facultadas</strong>", son el Ministerio P&uacute;blico y/o aquellas instancias de seguridad, procuraci&oacute;n de justicia y administraci&oacute;n de justicia que, conforme a sus atribuciones previstas en las leyes aplicables o en acuerdos delegatorios publicados en el DOF, cuenten con la facultad expresa para: i) requerir la GL en tiempo real de los equipos de comunicaci&oacute;n, as&iacute; como ii) la entrega de los DC por los Concesionarios y Autorizados, y iii) la IL, siempre y cuando cuenten con orden debidamente fundada y</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>&ldquo;<strong>Autoridades Designadas</strong>&rdquo;, es todo aquel servidor p&uacute;blico que haya sido designado por los titulares de las Autoridades Facultadas mediante acuerdos publicados en el DOF, de conformidad con lo dispuesto en el art&iacute;culo 189 de la LFTyR, para gestionar los requerimientos que, en los t&eacute;rminos establecidos en las leyes aplicables, se realicen a los Concesionarios y los Autorizados, y recibir la informaci&oacute;n</li>
</ol>
<p>&nbsp;</p>
<h4><u>CUARTA.&nbsp; Requerimientos de la Autoridad.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Geolocalizaci&oacute;n. </strong>La Autoridad Facultada o Autoridad Designada podr&aacute; requerir la GL en tiempo real de los equipos de comunicaci&oacute;n, siempre y cuando cuenten con orden debidamente fundada y motivada expedida por: <em>(i) </em>una Autoridad Judicial Federal (Juez Federal del orden Penal), o; <em>(ii) </em>en su caso, Juez de Control del Fuero Com&uacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Excepcionalmente, el Ministerio P&uacute;blico podr&aacute; solicitar la informaci&oacute;n sin orden judicial, siempre y cuando obtenga en 48 (cuarenta y ocho) horas la ratificaci&oacute;n total o parcial, de conformidad con las excepciones del art&iacute;culo 303 del CNPP, a saber:</p>
<p>&nbsp;</p>
<ol>
<li>Cuando est&eacute; en peligro la integridad f&iacute;sica o la vida de una persona;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Se encuentre en riesgo el objeto del delito;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Hechos relacionados con la privaci&oacute;n ilegal de la libertad;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Secuestro;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Extorsi&oacute;n, o;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Delincuencia</li>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong>Datos Conservados. </strong>La Autoridad Facultada o Designada podr&aacute; requerir la entrega de los DC por los Concesionarios y Autorizados, siempre y cuando cuenten con orden debidamente fundada y motivada expedida por: <em>(i) </em>una Autoridad Judicial Federal (Juez Federal del orden Penal), o; <em>(ii) </em>en su caso, Juez de Control del Fuero Com&uacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Excepcionalmente, el Ministerio P&uacute;blico podr&aacute; solicitar la informaci&oacute;n sin orden judicial, siempre y cuando obtenga en 48 (cuarenta y ocho) horas la ratificaci&oacute;n total o parcial, de conformidad con las excepciones del art&iacute;culo 303 del CNPP, a saber:</p>
<p>&nbsp;</p>
<ol>
<li>Cuando est&eacute; en peligro la integridad f&iacute;sica o la vida de una persona;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Se encuentre en riesgo el objeto del delito;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Hechos relacionados con la privaci&oacute;n ilegal de la libertad;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Secuestro;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Extorsi&oacute;n, o;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Delincuencia</li>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong>Intervenci&oacute;n de Comunicaciones. </strong>La Autoridad Facultada podr&aacute; requerir la IL de comunicaciones, siempre y cuando cuente con orden debidamente fundada y motivada expedida por una autoridad Judicial Federal (Juez Federal del orden Penal). Si no se cumple la condici&oacute;n se&ntilde;alada en el presente p&aacute;rrafo, <u>en ning&uacute;n momento Alt&aacute;n estar&aacute; obligada a compartir la informaci&oacute;n solicitada</u>.</li>
</ul>
<p>&nbsp;</p>
<h4><u>QUINTA. Opciones del Cliente.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En tanto el Cliente no cuente con los medios y la infraestructura necesarios para dar respuesta oportuna a los requerimientos de las Autoridades Facultadas y/o</li>
</ul>
<p>&nbsp;</p>
<p>Delegadas, Alt&aacute;n queda obligado<sup><a href="#_bookmark20">1 </a></sup>a prestarle los servicios necesarios para que el Cliente, de forma directa, pueda cumplir en tiempo y forma (la &ldquo;<strong>Opci&oacute;n B</strong>&rdquo;).</p>
<p>&nbsp;</p>
<ul>
<li>En el caso de que el Cliente s&iacute; cuente con la infraestructura y medios necesarios para dar respuesta oportuna a los requerimientos de las Autoridades Facultadas y/o Delegadas, el Cliente no podr&aacute; hacer uso de los servicios que Alt&aacute;n dispone a trav&eacute;s del presente Acuerdo y Alt&aacute;n no tendr&aacute; ni asumir&aacute; por la suscripci&oacute;n del presente ninguna de las obligaciones y/o responsabilidades materia del presente Acuerdo (la &ldquo;<strong>Opci&oacute;n A</strong>&rdquo;).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de que el Cliente cuente parcialmente con la infraestructura y medios necesarios para dar respuesta a alguno de los requerimientos de las Autoridades Facultadas y/o Delegadas, pero requiera contratar a Alt&aacute;n alguno de los servicios establecidos en el presente Acuerdo (DC y/o GL, y/o IL) para los cuales no cuente con la infraestructura y medios necesarios, Alt&aacute;n podr&aacute; alternativamente prestarle los servicios contratados para que el Cliente pueda cumplir en tiempo y forma. En este &uacute;ltimo caso, el Cliente deber&aacute; atenerse a lo establecido en el presente Acuerdo, en lo que resulte aplicable (la &ldquo;<strong>Opci&oacute;n C</strong>&rdquo;).</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEXTA. Obligaciones de Alt&aacute;n.</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En raz&oacute;n y para la instrumentaci&oacute;n y aplicaci&oacute;n de todo lo anterior, el Cliente selecciona en este acto los servicios (de forma alternativa o conjuntiva DC y/o GL, y/o IL en t&eacute;rminos de los art&iacute;culos 1961 y 1962 del C&oacute;digo Civil Federal) que necesita y desea contratar, por no contar con los medios y la infraestructura necesarios para dar respuesta oportuna a los requerimientos de las Autoridades Facultadas y/o Delegadas, de acuerdo con la Tabla 1 siguiente.</p>
<p>&nbsp;</p>
<p>El Cliente puede elegir la Opci&oacute;n A, para lo cual Alt&aacute;n no tendr&aacute; responsabilidad alguna frente al Cliente.</p>
<p>&nbsp;</p>
<p>El Cliente puede elegir la Opci&oacute;n B o la Opci&oacute;n C con cualesquiera de las opciones C.1, C.2., y C.3. que requiera.</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="472">
<p><strong>Opciones de Servicio(s) de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia</strong></p>
</td>
<td width="117">
<p><strong>Opci&oacute;n seleccionada</strong></p>
<p><strong>por el Cliente</strong></p>
</td>
</tr>
<tr>
<td colspan="2" width="472">
<p><strong>Opci&oacute;n A. </strong>Ning&uacute;n servicio para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia salvo por la conexi&oacute;n establecida en el Contrato de Integraci&oacute;n para que el Cliente acceda directamente a toda la informaci&oacute;n que puede ser requerida por Autoridades</p>
<p>Delegadas y Facultadas en t&eacute;rminos de este Ap&eacute;ndice y los Lineamientos aplicables.</p>
</td>
<td width="117">
<p>&nbsp;</p>
<p>( )</p>
</td>
</tr>
<tr>
<td colspan="2" width="472">
<p><strong>Opci&oacute;n B. </strong>Todos los servicios para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia (a elecci&oacute;n del Cliente todos los servicios C.1, C.2. y C.3. , descritos en la Opci&oacute;n C abajo.)</p>
</td>
<td width="117">
<p>&nbsp;</p>
<p>( X )</p>
</td>
</tr>
<tr>
<td width="316">
<p><strong>Opci&oacute;n C. </strong>Alguno o algunos de los servicios para la Colaboraci&oacute;n con las Instancias de Seguridad,</p>
</td>
<td width="156">
<p>C.1. Datos</p>
<p>Conservados (DC)</p>
</td>
<td width="117">
<p>( )</p>
</td>
</tr>
<tr>
<td width="316">&nbsp;</td>
<td width="156">&nbsp;</td>
<td width="117">&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="113">&nbsp;</td>
</tr>
<tr>
<td>&nbsp;</td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>1 Lineamiento Primero, p&aacute;rrafo tercero de los Lineamientos de Colaboraci&oacute;n en Materia de Seguridad y Justicia, publicados en el DOF el 2 de diciembre de 2015.</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="472">
<p><strong>Opciones de Servicio(s) de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia</strong></p>
</td>
<td width="117">
<p><strong>Opci&oacute;n seleccionada por el Cliente</strong></p>
</td>
</tr>
<tr>
<td rowspan="2" width="316">
<p>Procuraci&oacute;n y Administraci&oacute;n de Justicia, (a elecci&oacute;n del Cliente, C.1, C.2., y/o C.3.)</p>
</td>
<td width="156">
<p>C.2. Geolocalizaci&oacute;n (GL)</p>
</td>
<td width="117">
<p>&nbsp;</p>
<p>( )</p>
</td>
</tr>
<tr>
<td width="156">
<p>C.3. Intervenci&oacute;n Legal de comunicaciones (IL)</p>
</td>
<td width="117">
<p>( )</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><em>Tabla 1. Servicio(s) de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia seleccionados por el Cliente.</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<h4><u>S&Eacute;PTIMA. Reglas Generales de la Colaboraci&oacute;n en materia de Seguridad y Justicia.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Obligaciones, Responsabilidades y alcance de la Coadyuvancia en la gesti&oacute;n de requerimientos de Colaboraci&oacute;n en materia de Seguridad y Justicia</strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<ol>
<li>Los requerimientos de Colaboraci&oacute;n con la Seguridad y Justicia s&oacute;lo pueden ser solicitados por una Autoridad Facultada o Autoridad</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Ambas Partes acuerdan que, en materia de colaboraci&oacute;n con la seguridad y la justicia, las obligaciones y responsabilidades de cada una de ellas ser&aacute;n las establecidas en el presente Acuerdo, as&iacute; como en las disposiciones reglamentarias en lo que resulten aplicables en materia de colaboraci&oacute;n de seguridad y justicia y no se encuentre expresamente establecido en el presente Acuerdo para regir la relaci&oacute;n entre las</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En el presente Acuerdo, se establecen las obligaciones y responsabilidades para cada una de las Partes involucradas en la prestaci&oacute;n de servicios de Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de</li>
</ol>
<p>&nbsp;</p>
<h4>7.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Procedimiento general para la gesti&oacute;n de requerimientos de Colaboraci&oacute;n con la Seguridad y Justicia</h4>
<p><strong>&nbsp;</strong></p>
<p>En los casos en que el Cliente reciba un oficio por parte de la Autoridad Facultada o Autoridad Designada, por el que se ordena la entrega de determinada informaci&oacute;n sobre GL y/o sobre DC, y/o la IL de comunicaciones, se observar&aacute;n las disposiciones siguientes:</p>
<p>&nbsp;</p>
<ol>
<li>Es obligaci&oacute;n del Cliente llevar a cabo la validaci&oacute;n y an&aacute;lisis legal sobre el requerimiento; es decir, el Cliente deber&aacute; asegurarse que el oficio est&eacute; debidamente fundado y motivado, y que la Autoridad que emiti&oacute; el requerimiento sea una Autoridad Facultada o Designada, liberando a Alt&aacute;n de cualquier responsabilidad que se genere por el desahogo del requerimiento que haya sido previamente validado por el Cliente.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Con la finalidad de coadyuvar tanto con el Cliente como con las Autoridades Facultadas y Designadas, Alt&aacute;n establecer&aacute; el siguiente correo electr&oacute;nico<u><a href="mailto:seguridadyjusticia@altanredes.comc"> seguridadyjusticia@altanredes.com </a></u>como canal de comunicaci&oacute;n y recepci&oacute;n de informaci&oacute;n, el cual estar&aacute; disponible las 24 horas del d&iacute;a los 7 d&iacute;as de las semana; en los casos en que el Cliente no disponga de las plataformas y/o herramientas que le permitan responder de manera oportuna a los requerimientos de la Autoridad Facultada o Designada. El Cliente enviar&aacute; &uacute;nicamente al correo previsto en este p&aacute;rrafo toda solicitud y comunicaci&oacute;n relacionada con el presente</li>
</ol>
<p>&nbsp;</p>
<p>El Cliente se obliga a enviar todo comunicado relacionado con el presente Acuerdo desde el correo <u><a href="mailto:miguel@elux.com.mx">miguel@elux.com.mx</a></u>, mismo que ser&aacute; la &uacute;nica direcci&oacute;n electr&oacute;nica desde la cual Alt&aacute;n podr&aacute; dar contestaci&oacute;n al Cliente.</p>
<p>&nbsp;</p>
<p>Toda solicitud de informaci&oacute;n, sin excepci&oacute;n alguna, deber&aacute; contener la siguiente informaci&oacute;n para ser atendida:</p>
<p>&nbsp;</p>
<ol>
<li>el Formato de Coadyuvancia adjunto al presente Ap&eacute;ndice;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Copia del Oficio de Requerimiento; es decir, el Acuerdo emitido por Autoridad Facultada o Autoridad Designada, por el cual se hace la solicitud formal al Cliente en t&eacute;rminos del art&iacute;culo 189 de la LFTyR, por el que se ordena GL, y/o entrega de Datos Conservados, y/o la IL de comunicaciones; el cual deber&aacute; cumplir con los siguientes requisitos:
<ul>
<li>Fecha y lugar;</li>
<li>Nombre y cargo del servidor p&uacute;blico requirente e Instituci&oacute;n a la que pertenece;</li>
<li>Fecha en que se public&oacute; en el DOF la designaci&oacute;n de la Autoridad Designada;</li>
<li>Estar fundado y motivado;</li>
<li>Nombre y cargo de la Autoridad Judicial que autoriza, adjuntando dicha autorizaci&oacute;n;</li>
<li>Se&ntilde;alar los sujetos de intervenci&oacute;n;</li>
<li>Identificaci&oacute;n del lugar(es) donde se realizar&aacute;, si es posible;</li>
<li>Objeto de la solicitud:</li>
</ul>
</li>
<li>GL, y/o;</li>
<li>Entrega de DC, y/o;</li>
</ol>
<ul>
<li>IL de
<ul>
<li>Tipo de comunicaci&oacute;n que ser&aacute; intervenida;</li>
<li>Periodo por el que se solicita la informaci&oacute;n;</li>
<li>N&uacute;mero(s) telef&oacute;nico(s) a diez d&iacute;gitos, IMSI o IMEI objeto del requerimiento; y</li>
</ul>
</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Denominaci&oacute;n o Raz&oacute;n Social del</li>
<li>Formatos en el que se requiere sea entregada la informaci&oacute;n (por ejemplo "pdf", ".xls" o ".csv");</li>
<li>Sello de la Instituci&oacute;n; y</li>
<li>Firma aut&oacute;grafa o electr&oacute;nica del servidor p&uacute;blico</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La declaraci&oacute;n de haber realizado la validaci&oacute;n del requerimiento, con la leyenda <em>&ldquo;Bajo protesta de decir verdad, el requerimiento que se adjunta al presente correo ha sido validado y es procedente, por lo cual se libera a Alt&aacute;n de cualquier responsabilidad que se genere por la atenci&oacute;n al mismo&rdquo;.</em></li>
</ul>
<p><em>&nbsp;</em></p>
<p>El Cliente reconoce expresamente que en caso de no incluir la informaci&oacute;n requerida en el presente numeral 7.2, <u>Alt&aacute;n no ser&aacute; responsable de la entrega</u> <u>de la informaci&oacute;n</u>.</p>
<p>&nbsp;</p>
<ol>
<li>Los tiempos de atenci&oacute;n por parte de Alt&aacute;n para la entrega de la informaci&oacute;n solicitada por el Cliente son los se&ntilde;alados en la columna III de la Tabla 2, en los casos en que el Cliente no disponga de las plataformas y/o herramientas que le permitan responder de manera oportuna a los requerimientos de la Autoridad Facultada o Designada, tal como se describe a continuaci&oacute;n:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="121">
<p><strong>I. Plazo de respuesta</strong></p>
<p><strong>se&ntilde;alado en el requerimiento</strong></p>
</td>
<td width="121">
<p><strong>II. Plazo del Cliente contado</strong></p>
<p><strong>a partir de la recepci&oacute;n del</strong></p>
<p><strong>requerimiento</strong></p>
</td>
<td width="137">
<p><strong>III. Plazo de Alt&aacute;n a partir de la</strong></p>
<p><strong>recepci&oacute;n de la solicitud por parte</strong></p>
<p><strong>del Cliente</strong></p>
</td>
<td width="154">
<p><strong>IV. Plazo del Cliente para enviar la respuesta a la</strong></p>
<p><strong>Autoridad Facultada</strong></p>
</td>
</tr>
<tr>
<td width="121">
<p>1 hora</p>
</td>
<td width="121">
<p>15 minutos</p>
</td>
<td width="137">
<p>30 minutos Para este caso, el correo deber&aacute; ser marcado en &ldquo;Asunto&rdquo; como &ldquo;<strong>URGENTE [*] N&Uacute;MERO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; DE</strong></p>
<p><strong>OFICIO&rdquo; </strong>para que se pueda atender de manera inmediata. En adici&oacute;n, el Cliente deber&aacute; llamar al tel&eacute;fono <strong><u>(55) 8633</u> <u>6166</u> </strong>para informar a Alt&aacute;n que tiene un requerimiento con tiempo de respuesta</p>
<p>de 1 hora.</p>
</td>
<td width="154">
<p>15 minutos</p>
</td>
</tr>
<tr>
<td width="121">
<p>24 horas</p>
</td>
<td width="121">
<p>4 horas</p>
</td>
<td width="137">
<p>14 horas</p>
</td>
<td width="154">
<p>6 horas</p>
</td>
</tr>
<tr>
<td width="121">
<p>48 horas</p>
</td>
<td width="121">
<p>8 horas</p>
</td>
<td width="137">
<p>24 horas</p>
</td>
<td width="154">
<p>16 horas</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><em>Tabla 2. Tiempos de Respuesta</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<p>En caso de que la solicitud de Autoridad prevea plazos superiores a los establecidos en la Tabla 2 precedente, los tiempos de atenci&oacute;n por parte de Alt&aacute;n para la entrega de la informaci&oacute;n solicitada por el Cliente, correspondientes a la columna III, nunca podr&aacute;n ser menores al triple del Plazo del Cliente previsto en la columna II de la Tabla 2 anterior, ni menores a los plazos definidos cuando el Plazo de respuesta se&ntilde;alado en el requerimiento sea de 48 horas.</p>
<p>&nbsp;</p>
<p>Lo anterior, se establece de conformidad con los LCMSJ vigentes a 2019, por lo que derivado de cualquier modificaci&oacute;n que pudiera sufrir la LFTyR y/o los LCMSJ, se deber&aacute;n ajustar los plazos de respuesta con la finalidad de dar cumplimiento oportuno a las Autoridades Facultadas y Delegadas en materia de seguridad y justicia.</p>
<p>&nbsp;</p>
<ol>
<li>Una vez recibida la informaci&oacute;n enlistada en el inciso b) anterior, y dentro del Plazo del Cliente seg&uacute;n se indica en la Tabla 2 precedente, Alt&aacute;n proceder&aacute; a dar respuesta al Cliente dentro del Plazo de Alt&aacute;n. Dicha respuesta ser&aacute; enviada al Cliente por correo electr&oacute;nico a la cuenta indicada por el Cliente en el inciso</li>
<li>b) anterior, que es el <u>&uacute;nico</u> correo autorizado y notificado a Alt&aacute;n, con la finalidad de que el Cliente la utilice para dar contestaci&oacute;n formal a la Autoridad Facultada y/o Designada y recibir cualquier respuesta en t&eacute;rminos del presente Acuerdo. El Cliente reconoce y acepta que la cuenta deber&aacute; tener una capacidad de almacenamiento no menor a 500 MB y para documentos adjuntos de 10 MB, en caso contrario el Cliente reconoce y acepta que Alt&aacute;n no ser&aacute; responsable por la falta de recepci&oacute;n de la respuesta por parte de Alt&aacute;n. En caso de que el Cliente no cumpla con el Plazo del Cliente, el Cliente ser&aacute; el &uacute;nico responsable y deber&aacute; sacar en paz y a salvo a Alt&aacute;n de cualquier</li>
</ol>
<p>&nbsp;</p>
<ol start="7">
<li>En caso de que el Cliente no adjunte copia del requerimiento de la Autoridad Facultada y/o Designada, y/o incumpla con lo establecido en el inciso b) del presente numeral 2, Alt&aacute;n no podr&aacute; dar contestaci&oacute;n al correo electr&oacute;nico ni al env&iacute;o de informaci&oacute;n, por lo que el &uacute;nico responsable de cualquier procedimiento y/o sanci&oacute;n que se llegar&aacute; a imponer por incumplir con las Obligaciones en materia de colaboraci&oacute;n con la Seguridad y la Justicia ser&aacute; el Cliente, siendo este &uacute;ltimo el &uacute;nico responsable y deber&aacute; sacar en paz y a salvo a Alt&aacute;n de ese incumplimiento.</li>
</ol>
<p>&nbsp;</p>
<p>Asimismo, Alt&aacute;n notificar&aacute; al Cliente que se ha excedido el tiempo de entrega de la informaci&oacute;n enlistada en la presente Cl&aacute;usula con la siguiente leyenda:</p>
<p>&nbsp;</p>
<p>&ldquo;<em>Alt&aacute;n Redes notifica a ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V. (en lo sucesivo, el &ldquo;Cliente&rdquo;) del incumplimiento del Plazo del Cliente se&ntilde;alado en la Tabla 2 del Ap&eacute;ndice 11.7 Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia, suscrito entre Alt&aacute;n Redes y el Cliente el d&iacute;a 7 de diciembre de 2021, por lo que el Cliente es el &uacute;nico responsable de las sanciones que pudieran generarse por el incumplimiento del oficio de requerimiento adjunto al presente correo, por lo que el Cliente se obliga a sacar y mantener en paz y a salvo a Alt&aacute;n Redes de cualquier controversia y/o contingencia que se pudiera generar por dicho incumplimiento.</em>&rdquo;</p>
<p>&nbsp;</p>
<ol>
<li>Derivado de lo anterior, ambas Partes acuerdan que la responsabilidad de Alt&aacute;n, s&oacute;lo ser&aacute; aplicable cuando incumpla en su obligaci&oacute;n de proporcionar al Cliente la informaci&oacute;n solicitada por la Autoridad Facultada o Designada en tiempo y/o en forma, de acuerdo con los tiempos acordados para su cumplimiento en los t&eacute;rminos de la Tabla 2 precedente, y con los mejores recursos tecnol&oacute;gicos que le sea posible, en los t&eacute;rminos y condiciones se&ntilde;alados en el presente Ap&eacute;ndice. El &uacute;nico obligado en entregar la informaci&oacute;n a las Autoridades Facultadas o Delegadas ser&aacute; el</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En el supuesto de que Alt&aacute;n requiera de un plazo mayor a los estipulados en la Tabla 2 &ldquo;Tiempos de Respuesta&rdquo;, para dar atenci&oacute;n espec&iacute;fica a alg&uacute;n requerimiento por parte de las Autoridades Facultadas y/o Designadas en materia de seguridad y justicia, podr&aacute; comunicarlo de manera inmediata al Cliente y se&ntilde;alar el tiempo en que podr&iacute;a retrasarse la entrega de la informaci&oacute;n y por el que solicitar&iacute;a una extensi&oacute;n de los plazos previstos en la Columna II de la Tabla 2 precedente. Lo anterior para que el Cliente solicite a la autoridad una pr&oacute;rroga y no incurrir en alg&uacute;n incumplimiento. La pr&oacute;rroga solo se entender&aacute; otorgada de forma expresa y deber&aacute; de ser comunicada al efecto por el Cliente a Alt&aacute;n tan pronto como sea en su caso otorgada por las Autoridades Facultadas o Delegadas. En el caso de que habi&eacute;ndose otorgado la pr&oacute;rroga por dichas Autoridades Facultadas y/o Delegadas, la misma no fuere notificada a Alt&aacute;n, Alt&aacute;n no tendr&aacute; ninguna responsabilidad por no cumplir con los t&eacute;rminos de la misma o con los t&eacute;rminos del requerimiento original. En caso de que Alt&aacute;n requiera un plazo mayor en t&eacute;rminos del presente inciso, y el Cliente no solicite a la Autoridad una pr&oacute;rroga, Alt&aacute;n no tendr&aacute; ninguna responsabilidad por no cumplir con los t&eacute;rminos del requerimiento</li>
</ol>
<p>&nbsp;</p>
<h4><u>OCTAVA. Procedimiento para el Servicio de entrega de Datos Conservados para</u> <u>Colaboraci&oacute;n con la Seguridad y Justicia</u>.</h4>
<p><strong>&nbsp;</strong></p>
<p>El Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de DC, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar&aacute; que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com</a></u> el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, ser&aacute; enviada al correo electr&oacute;nico designado por el Cliente la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<p>detalle de las llamadas en formato PDF, el cual, estar&aacute; integrado por la siguiente informaci&oacute;n: (i) n&uacute;mero de l&iacute;nea; (ii) tipo de servicio (iii) n&uacute;mero A; (iv) n&uacute;mero B; (v) fecha; (vi) hora; (vii) duraci&oacute;n en segundos de la llamada, y (viii) ubicaci&oacute;n geogr&aacute;fica.</p>
<p>&nbsp;</p>
<ol>
<li>Concluida la entrega de informaci&oacute;n de acuerdo con lo anterior, Alt&aacute;n enviar&aacute; un reporte de Conclusi&oacute;n de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el</li>
</ol>
<p>&nbsp;</p>
<h4><u>NOVENA. Procedimiento para el Servicio de Geolocalizaci&oacute;n para Colaboraci&oacute;n con</u> <u>la Seguridad y Justicia</u>.</h4>
<p><strong>&nbsp;</strong></p>
<p>Se define la GL como la ubicaci&oacute;n geogr&aacute;fica de un Usuario Final del Cliente en la red de Alt&aacute;n, en una fecha y hora espec&iacute;fica.</p>
<p>&nbsp;</p>
<p>Los requerimientos de GL para Colaboraci&oacute;n con la Seguridad y Justicia pueden catalogarse en las siguientes modalidades:</p>
<p>&nbsp;</p>
<ul>
<li><u>Servicio de Geolocalizaci&oacute;n Hist&oacute;rica</u>: cuando se solicitan para fechas y/u horas registradas en el pasado (hasta m&aacute;ximo veinticuatro meses) de acuerdo con los LCMSJ.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><u>Servicio de Geolocalizaci&oacute;n en Tiempo Real</u>: cuando se solicita que sean reportadas en el momento mismo del requerimiento, y/o cuando se mantenga un monitoreo por un espacio de tiempo</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><u>Servicio de Geolocalizaci&oacute;n por tiempo determinado</u>: cuando se solicita que se mantenga un monitoreo por un espacio de tiempo</li>
</ul>
<p>&nbsp;</p>
<h4>9.1.&nbsp;&nbsp;&nbsp;&nbsp; Servicio de Geolocalizaci&oacute;n Hist&oacute;rica</h4>
<p><strong>&nbsp;</strong></p>
<p>El Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de GL hist&oacute;rica, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar dentro del Plazo del Cliente, al correo electr&oacute;nico<u><a href="mailto:seguridadyjusticia@altanredes.com"> seguridadyjusticia@altanredes.com </a></u>el Formato de Coadyuvancia y el requerimiento respectivo dentro del plazo se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, ser&aacute; enviada en formato de Microsoft Word al correo electr&oacute;nico designado</li>
</ol>
<p>&nbsp;</p>
<p>por el Cliente la informaci&oacute;n respecto de la ubicaci&oacute;n digital del Usuario Final, que se corresponde con el identificador de celda para el servicio m&oacute;vil provisto por Alt&aacute;n.</p>
<p>&nbsp;</p>
<h4>9.2.&nbsp;&nbsp;&nbsp;&nbsp; Servicio de Geolocalizaci&oacute;n en Tiempo Real</h4>
<p><strong>&nbsp;</strong></p>
<p>El Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de GL en tiempo real, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com</a></u> el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, ser&aacute; enviada en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente la informaci&oacute;n respecto de las coordenadas geogr&aacute;ficas determinadas por los valores manifestados en Latitud y Longitud en el momento en que sea recibida por Alt&aacute;n.</li>
</ol>
<p>&nbsp;</p>
<h4>9.3.&nbsp;&nbsp;&nbsp;&nbsp; Servicio de Geolocalizaci&oacute;n por tiempo determinado</h4>
<p><strong>&nbsp;</strong></p>
<p>En todo caso el Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de GL por tiempo determinado, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com</a></u> el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente establecido en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Al comienzo de la GL por tiempo determinado, Alt&aacute;n enviar&aacute; un Reporte de Inicio de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Las coordenadas solicitadas en el Requerimiento por la Autoridad Facultada se enviar&aacute;n de manera autom&aacute;tica al Correo del Cliente, durante el periodo de tiempo determinado y periodicidad definida en dicho</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Al t&eacute;rmino de la GL por tiempo determinado definido por la Autoridad Facultada, Alt&aacute;n enviar&aacute; al Correo del Cliente un Reporte de Conclusi&oacute;n de Actividades en formato de Word.</li>
</ol>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMA. Procedimiento para el Servicio de Intervenci&oacute;n Legal de comunicaciones</u> <u>para Colaboraci&oacute;n con la Seguridad y Justicia.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>La Intervenci&oacute;n Legal es el servicio de entrega a las autoridades del contenido de una comunicaci&oacute;n de un Usuario Final sobre la red de Alt&aacute;n, siempre y cuando medie una orden judicial debidamente fundada y motivada, por una Autoridad Facultada (en este caso, s&oacute;lo por mandamiento de Juez Federal Penal Especializado en Cateos, Arraigos e Intervenci&oacute;n de Comunicaciones).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n no realiza ning&uacute;n tipo de almacenamiento del contenido de las comunicaciones intervenidas, y por tanto la compartici&oacute;n de la misma s&oacute;lo podr&aacute; realizarse mediante el requerimiento de la Autoridad Facultada al Cliente de Alt&aacute;n y el &uacute;nico facultado para almacenar dicha informaci&oacute;n ser&aacute; la Autoridad</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Se debe tener en cuenta que toda la informaci&oacute;n cursada por los Usuarios Finales sobre la red de Alt&aacute;n est&aacute; encriptada en cualquiera de sus servicios y el &uacute;nico facultado para desencriptar el contenido es la Autoridad Facultada que ha realizado el</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente deber&aacute; observar los requisitos previstos en el numeral 2 precedente para dar respuesta oportuna a un requerimiento de IL, y seguir el siguiente procedimiento:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com </a></u>el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, se habilitar&aacute; la IL del n&uacute;mero solicitado y se le dar&aacute; acceso a la Autoridad Facultada, durante el tiempo determinado en la Orden de Intervenci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<p>Al comienzo de la IL, Alt&aacute;n enviar&aacute; un Reporte de Inicio de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente.</p>
<p>&nbsp;</p>
<p>Concluido el plazo de la intervenci&oacute;n, Alt&aacute;n enviar&aacute; un reporte de Conclusi&oacute;n de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente para que &eacute;ste de contestaci&oacute;n formal al requerimiento de la Autoridad Facultada.</p>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO PRIMERA. Obligaciones y Responsabilidades de las Partes.</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>11.1 Obligaciones y Responsabilidades de Alt&aacute;n</strong></p>
<p><strong>&nbsp;</strong></p>
<ol>
<li>Alt&aacute;n contar&aacute; con las herramientas necesarias para prestar al Cliente los servicios necesarios para que este &uacute;ltimo de forma directa pueda cumplir de manera oportuna con los requerimientos de informaci&oacute;n que se desprenden de los ordenamientos jur&iacute;dicos en materia de colaboraci&oacute;n con las instancias de seguridad, procuraci&oacute;n y administraci&oacute;n de justicia, con relaci&oacute;n al presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Alt&aacute;n informar&aacute; a las Autoridades Facultadas y Designadas que cuenta con un &Aacute;rea Responsable en t&eacute;rminos de lo dispuesto por la LFTyR, para atender las solicitudes de IL de comunicaciones, GL, Entrega y Conservaci&oacute;n de DC, de manera inmediata y con la suficiencia</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente un correo electr&oacute;nico para la atenci&oacute;n de requerimientos de informaci&oacute;n en materia de seguridad y justicia de Autoridades Facultadas y Designadas, sobre i) DC, ii) GL, y iii) &oacute;rdenes judiciales para la IL de comunicaciones. Alt&aacute;n ser&aacute; responsable de procesar y generar la informaci&oacute;n recibida a trav&eacute;s de dicho correo, siempre y cuando el Cliente cumpla con los requisitos y plazos establecidos en el presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Alt&aacute;n coadyuvar&aacute; con el Cliente para la atenci&oacute;n de requerimientos de las Autoridades Facultadas y Designadas en materia de seguridad y justicia con la mayor diligencia posible, en los t&eacute;rminos y condiciones del presente</li>
</ol>
<p>&nbsp;</p>
<h4>11.2.&nbsp; Obligaciones y Responsabilidades del Cliente</h4>
<p><strong>&nbsp;</strong></p>
<ol>
<li>El Cliente es el responsable de recibir y gestionar oportunamente los requerimientos de informaci&oacute;n provenientes de la Autoridad Facultada y/o</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente deber&aacute; responder de forma directa, a su entera responsabilidad, los requerimientos de las Autoridades Facultadas y Designadas; es decir, el Cliente ser&aacute;</li>
</ol>
<p>&nbsp;</p>
<p>el &uacute;nico responsable de dar contestaci&oacute;n a los requerimientos en materia de seguridad y justicia.</p>
<p>&nbsp;</p>
<ol>
<li>El Cliente ser&aacute; el &uacute;nico responsable de atender los requerimientos de informaci&oacute;n de las Autoridades Facultadas o Designadas, en las que se soliciten datos personales del Usuario Final. En todo momento, el Cliente deber&aacute; cumplir el tratamiento y manejo adecuado de los datos personales que haya obtenido de sus usuarios por motivo de su operaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente ser&aacute; el &uacute;nico responsable de validar legalmente que el requerimiento se encuentre debidamente fundado y motivado, as&iacute; como emitido por una Autoridad Facultada o Designada. Es importante enfatizar que en ning&uacute;n momento Alt&aacute;n ser&aacute; responsable de lo anterior, y por lo tanto no realizar&aacute; ning&uacute;n tipo de an&aacute;lisis legal de los requerimientos notificados por la Autoridad Facultada a sus Clientes, siendo &eacute;stos &uacute;ltimos los &uacute;nicos responsables de la validaci&oacute;n del requerimiento y, en su caso, de tomar la decisi&oacute;n de responder y aportar la informaci&oacute;n solicitada. Alt&aacute;n &uacute;nicamente pondr&aacute; dicha informaci&oacute;n a disposici&oacute;n del Cliente dentro de los t&eacute;rminos correspondientes para que &eacute;ste, a su criterio, decida entregarla o no a la Autoridad Facultada o</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente deber&aacute; disponer de las plataformas y/o herramientas propias que lo habiliten para dar respuesta oportuna a los requerimientos emitidos por la Autoridad Facultada o</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En caso de que el Cliente no disponga de las plataformas y/o herramientas que le permitan responder de manera oportuna a los requerimientos de la Autoridad Facultada o Designada en relaci&oacute;n con los DC y/o GL, deber&aacute; solicitar formalmente a Alt&aacute;n la informaci&oacute;n requerida, de conformidad con lo dispuesto en el presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Para el supuesto previsto en el inciso anterior, el Cliente se obliga a solicitar la informaci&oacute;n del requerimiento por parte de la Autoridad Facultada o Delegada, dentro de los plazos establecidos en la Tabla 2 del presente Acuerdo, para que Alt&aacute;n pueda entregar la informaci&oacute;n solicitada en el requerimiento de informaci&oacute;n, mismo que deber&aacute; ser previamente validado jur&iacute;dicamente por el</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente libera a Alt&aacute;n de toda responsabilidad por el procesamiento y la entrega de la informaci&oacute;n relacionada con los requerimientos en materia de colaboraci&oacute;n con la seguridad y la</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente pagar&aacute; a Alt&aacute;n las Tarifas se&ntilde;aladas en el presente Ap&eacute;ndice, por brindar al Cliente la informaci&oacute;n solicitada por la Autoridad Facultada o Designada, para dar contestaci&oacute;n a los requerimientos en materia de colaboraci&oacute;n con la seguridad y la justicia.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente es responsable del tratamiento y manejo adecuado de los datos personales que obtenga con motivo de su operaci&oacute;n, cumpliendo al efecto con la legislaci&oacute;n aplicable y su aviso de privacidad en cumplimiento con la Ley Federal de Datos Personales en Posesi&oacute;n de los Particulares y su Reglamento. En caso de cualquier reclamo relacionado con el tratamiento de datos personales, el Cliente deber&aacute; indemnizar, defender y sacar en paz y a salvo a Alt&aacute;n de cualquier monto que este &uacute;ltimo tenga que pagar por multas y/o indemnizaciones o por cualquier otro concepto, derivadas de procesos administrativos, civiles o transacciones que resuelvan el o los reclamos</li>
</ol>
<p>&nbsp;</p>
<p>Esta responsabilidad de indemnizar, defender y sacar en paz y a salvo a Alt&aacute;n por parte del Cliente estar&aacute; limitada a un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del Contrato.</p>
<p>&nbsp;</p>
<ol start="6">
<li>El Cliente deber&aacute; indemnizar, defender y sacar en paz y a salvo a Alt&aacute;n de cualquier controversia o reclamaci&oacute;n derivada del incumplimiento por parte del Cliente de sus obligaciones en materia de colaboraci&oacute;n con la seguridad y la justicia, hasta por un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del</li>
</ol>
<p>&nbsp;</p>
<h4>11.3.&nbsp; Responsabilidades aplicables a las Obligaciones de Alt&aacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Respecto de los LMCSJ, y al amparo de los art&iacute;culos 14 y 16 constitucionales, las Partes se obligan rec&iacute;procamente a indemnizarse y a sacarse en paz y a salvo de los da&ntilde;os y perjuicios que cada una de ellas cause, por su culpa o negligencia, a la otra. En lo particular las Partes acuerdan que:</p>
<p>&nbsp;</p>
<ul>
<li>En el caso de que el Cliente elija las Opciones B o C con cualquiera de sus opciones previstas en la Tabla 1 del presente Acuerdo, Alt&aacute;n indemnizar&aacute; y sacar&aacute; en paz y a salvo al Cliente de los da&ntilde;os y perjuicios que &eacute;ste experimente, en el caso de que i) Alt&aacute;n no atienda en tiempo y forma la solicitud del Cliente para coadyuvar con el requerimiento de informaci&oacute;n expedido por una Autoridad Facultada o Delegada, seg&uacute;n corresponda, siempre que ii) est&eacute; debidamente fundada y motivada, por la que se requiera directamente al Cliente, y iii) que cumpla con todos los requisitos de la secci&oacute;n 3.2</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En el caso planteado en la presente Cl&aacute;usula, la responsabilidad de Alt&aacute;n s&oacute;lo operar&aacute; cuando los da&ntilde;os y perjuicios que sufra el Cliente <u>a) sean consecuencia directa, inmediata y exclusiva del incumplimiento, b) se deban a culpa y/o negligencia de Alt&aacute;n en t&eacute;rminos de los art&iacute;culos 1910 y 2110 del C&oacute;digo Civil Federal, y c) lo anterior, sea debidamente acreditado en la sentencia respectiva contra la que no sea admisible recurso legal alguno</u>.</li>
</ul>
<p>&nbsp;</p>
<p>Lo anterior, en el entendido de que por consecuencia de la falta de atenci&oacute;n oportuna por parte de Alt&aacute;n se impute responsabilidad al Cliente mediante sentencia firme que no admita recurso legal alguno, y en donde se muestre entre</p>
<p>&nbsp;</p>
<p>la comunicaci&oacute;n de las Partes que la omisi&oacute;n para atender el requerimiento de informaci&oacute;n en cuesti&oacute;n fue responsabilidad de Alt&aacute;n, siempre que se acredite en la sentencia respectiva que:</p>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento del Cliente que ocasion&oacute; la sanci&oacute;n haya sido atribuible de manera inmediata, directa y exclusivamente a Alt&aacute;n;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento de Alt&aacute;n para con el Cliente en la atenci&oacute;n espec&iacute;fica de los requerimientos de las Autoridades Facultadas y Designadas en materia de seguridad y justicia, se verifique siempre que:</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>La informaci&oacute;n haya sido requerida directamente al Cliente, y que el oficio por el cual se solicita dicha informaci&oacute;n fue dirigido exclusivamente al Cliente;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los oficios de requerimientos estuvieron debidamente fundados y motivados conforme a derecho;</li>
</ol>
<p>&nbsp;</p>
<ol start="2">
<li>Alt&aacute;n fue debidamente notificado conforme a lo establecido por el numeral 2.2 del presente Acuerdo, cumpliendo con todo los requisitos y plazos previstos ah&iacute; establecidos, y;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los oficios de requerimientos fueron confirmados respecto de todo lo anterior y autorizadas por parte del Cliente para su tr&aacute;mite por Alt&aacute;n.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El incumplimiento al presente Acuerdo no se debi&oacute;, directa o indirectamente, a un evento de Fuerza</li>
</ul>
<p>&nbsp;</p>
<p>En el caso de que el Cliente elija las Opciones B o C con cualquiera de sus opciones previstas en la Tabla 1 del presente Acuerdo, la responsabilidad por parte de Alt&aacute;n para con el Cliente estar&aacute; siempre y en todo caso limitada a un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del Contrato.</p>
<p>&nbsp;</p>
<p>Bajo este supuesto, en ning&uacute;n caso Alt&aacute;n ser&aacute; responsable para con el Cliente por da&ntilde;os consecuenciales, punitivos, indirectos, da&ntilde;o moral, ni cualesquier otros distintos a los da&ntilde;os y perjuicios directamente relacionados y comprobados por el Cliente como consecuencia de un incumplimiento.</p>
<p>&nbsp;</p>
<ul>
<li>En caso de que una de las Partes as&iacute; lo requiera, las Partes deber&aacute;n reunirse para analizar la posibilidad de impugnar la sanci&oacute;n impuesta por la Autoridad Facultada o Designada. En caso de que las partes decidan que procede interponer alg&uacute;n medio de defensa, impugnaci&oacute;n o acci&oacute;n al respecto, el pago de la sanci&oacute;n quedar&aacute; suspendido hasta que se resuelva de manera firme e inapelable el medio de defensa, impugnaci&oacute;n o acci&oacute;n respectivo o hasta que las partes decidan que procede desistirse del mismo o transigir con la Lo anterior sin perjuicio del derecho de ambas partes para impugnar cualquier resoluci&oacute;n o acto de autoridad que afecte sus intereses, mismo que no quedar&aacute; limitado en caso alguno.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de que el Cliente, a solicitud o no de Alt&aacute;n, obtenga una pr&oacute;rroga en t&eacute;rminos de lo previsto por la secci&oacute;n 7.2, inciso g) <em>in fine, </em>la responsabilidad s&oacute;lo aplicar&aacute; en caso de incumplimiento con lo previsto en el presente Acuerdo, a partir de la conclusi&oacute;n de la pr&oacute;rroga que sea en su caso otorgada por la Autoridad Facultada y/o</li>
</ul>
<p>&nbsp;</p>
<h4>11.4.&nbsp; Responsabilidades aplicables a la Obligaciones de Alt&aacute;n para el caso en que el Cliente elija la Opci&oacute;n A.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Respecto de los LMCSJ, y al amparo de los art&iacute;culos 14 y 16 constitucionales, las Partes se obligan rec&iacute;procamente a indemnizarse y a sacarse en paz y a salvo de los da&ntilde;os y perjuicios que cada una de ellas cause, por su culpa o negligencia, a la otra. En lo particular las Partes acuerdan que:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En el caso de que el Cliente elija la Opci&oacute;n A de la Tabla 1 del presente Ap&eacute;ndice, Alt&aacute;n indemnizar&aacute; y sacar&aacute; en paz y a salvo al Cliente de los da&ntilde;os y perjuicios que &eacute;ste experimente, en el caso de que la conexi&oacute;n presente inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n que impida que el Cliente pueda acceder y obtener la informaci&oacute;n requerida seg&uacute;n el requerimiento de la Autoridad Facultada y/o</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En el caso descrito en el presente numeral 4.2, la responsabilidad de Alt&aacute;n s&oacute;lo operar&aacute; cuando los da&ntilde;os y perjuicios que sufra el Cliente <u>a) sean consecuencia directa, inmediata y exclusiva de los inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n previstos en el p&aacute;rrafo precedente, b) se deban a culpa y/o negligencia de Alt&aacute;n en t&eacute;rminos de los art&iacute;culos 1910 y 2110 del C&oacute;digo Civil Federal, y c) lo anterior, sea debidamente acreditado en la sentencia respectiva contra la que no sea admisible recurso legal alguno</u>.</li>
</ul>
<p>&nbsp;</p>
<p>Lo anterior, en el entendido de que por consecuencia de los inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n no atendidos o resueltos por parte de Alt&aacute;n se impute responsabilidad al Cliente mediante sentencia firme que no admita recurso legal alguno, y en donde se muestre entre la comunicaci&oacute;n de las Partes que los inconvenientes t&eacute;cnicos no fueron atendidos o resueltos por parte de Alt&aacute;n.</p>
<p>&nbsp;</p>
<ul>
<li>En el caso de que el Cliente elija la Opci&oacute;n A de la Tabla 1 del presente Acuerdo, Alt&aacute;n &uacute;nicamente responder&aacute; de los da&ntilde;os y perjuicios de acuerdo con lo anterior, siempre que adicionalmente a lo previsto en el numeral 11.2 precedente, se acredite en la sentencia respectiva que:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento del Cliente que ocasion&oacute; la sanci&oacute;n haya sido atribuible de manera inmediata, directa y exclusivamente a Alt&aacute;n;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento de Alt&aacute;n para con el Cliente en la atenci&oacute;n espec&iacute;fica de los requerimientos de las Autoridades Facultadas y Designadas en materia de seguridad y justicia, se verifique siempre que los inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n no fueron atendidos o resueltos por parte de Alt&aacute;n;</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El incumplimiento al presente Acuerdo no se debi&oacute;, directa o indirectamente, a un evento de Fuerza</li>
</ul>
<p>&nbsp;</p>
<p>En el caso de que el Cliente elija la Opci&oacute;n A, de la Tabla 1 del presente Acuerdo, la responsabilidad por parte de Alt&aacute;n para con el Cliente estar&aacute; siempre y en todo caso limitada a un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del Contrato.</p>
<p>&nbsp;</p>
<p>En el caso de que el Cliente elija la Opci&oacute;n A, de la Tabla 1 del presente Acuerdo, en ning&uacute;n caso Alt&aacute;n ser&aacute; responsable para con el Cliente por da&ntilde;os consecuenciales, punitivos, indirectos, da&ntilde;o moral, ni cualesquier otros distintos a los da&ntilde;os y perjuicios directamente relacionados y comprobados por el Cliente como consecuencia de un incumplimiento.</p>
<p>&nbsp;</p>
<ul>
<li>En caso de que una de las Partes as&iacute; lo requiera, las Partes deber&aacute;n reunirse para analizar la posibilidad de impugnar la sanci&oacute;n impuesta por la Autoridad Facultada o Designada. En caso de que las partes decidan que procede interponer alg&uacute;n medio de defensa, impugnaci&oacute;n o acci&oacute;n al respecto, el pago de la sanci&oacute;n quedar&aacute; suspendido hasta que se resuelva de manera firme e inapelable el medio de defensa, impugnaci&oacute;n o acci&oacute;n respectivo o hasta que las partes decidan que procede desistirse del mismo o transigir con la Lo anterior sin perjuicio del derecho de ambas partes para impugnar cualquier resoluci&oacute;n o acto de autoridad que afecte sus intereses, mismo que no quedar&aacute; limitado en caso alguno.</li>
</ul>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO SEGUNDA. Tarifas</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En caso de que el Cliente utilice los servicios contemplados en el presente Ap&eacute;ndice, deber&aacute; pagar las tarifas enlistadas en el mismo, las cuales estar&aacute;n sujetas a la legislaci&oacute;n fiscal aplicable, causando el Impuesto al Valor Agregado (IVA), as&iacute; como cualquier otro impuesto que resulte aplicable, por la gesti&oacute;n de requerimientos de Colaboraci&oacute;n con la Seguridad y Justicia siguientes: <strong><em>(i) </em></strong>GL en tiempo real; <strong><em>(ii) </em></strong>GL por tiempo determinado; <strong><em>(iii) </em></strong>Entrega de DC, y; <strong><em>(iv) </em></strong>IL de las comunicaciones.</p>
<p>&nbsp;</p>
<p>Las tarifas por cada env&iacute;o de correo electr&oacute;nico al Cliente con la informaci&oacute;n solicitada a Alt&aacute;n (&ldquo;<strong>costo por evento</strong>&rdquo;) para dar contestaci&oacute;n al requerimiento de la Autoridad Facultada ser&aacute;n las que se indican a continuaci&oacute;n:</p>
<p>&nbsp;</p>
<ol>
<li>GL en tiempo El costo por evento ser&aacute; de $0.60 (sesenta centavos de peso M.N.), Impuesto al Valor Agregado (&ldquo;IVA&rdquo;) incluido.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>GL por un periodo de tiempo determinado. El costo por evento ser&aacute; de $0.88 (ochenta y ocho centavos de peso M.N.) IVA</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Entrega de datos conservados. El costo por evento ser&aacute; de $0.88 (ochenta y ocho centavos de peso M.N.) IVA</li>
</ol>
<p>&nbsp;</p>
<ol start="2">
<li>Intervenci&oacute;n de las comunicaciones. El costo por cada IL ser&aacute; de $ 2.00 (dos pesos M.N.) IVA</li>
</ol>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO TERCERA. Confidencialidad</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Las Partes guardar&aacute;n estricta confidencialidad, respecto de la informaci&oacute;n que mutuamente se proporcionen o por aquella a la que tengan acceso con motivo de la ejecuci&oacute;n del presente Ap&eacute;ndice, debiendo asegurarse que la informaci&oacute;n que se proporcione por el personal que cada una designe, sea manejada bajo estricta confidencialidad.</p>
<p>&nbsp;</p>
<p>Las obligaciones contempladas en esta cl&aacute;usula permanecer&aacute;n vigentes y ser&aacute;n exigibles a&uacute;n en el caso de que las Partes dieran por terminado el presente Acuerdo, por un per&iacute;odo de 2 (dos) a&ntilde;os siguientes a su terminaci&oacute;n, en cumplimiento con la fracci&oacute;n II, del art&iacute;culo 190 de la LFTyR; y el sexto p&aacute;rrafo, del numeral 3, del considerando Quinto de los LCMSJ.</p>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO CUARTA. Causas de Terminaci&oacute;n Anticipada</u></h4>
<p><strong>&nbsp;</strong></p>
<p>El presente Ap&eacute;ndice podr&aacute; darse por terminado sin culpa por cualquiera de las Partes &uacute;nicamente bajo los siguientes supuestos:</p>
<p>&nbsp;</p>
<ol>
<li>En caso de destrucci&oacute;n total o parcial de la infraestructura que haga imposible la prestaci&oacute;n de los servicios del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>La terminaci&oacute;n del presente Acuerdo por cualquiera de la Partes previa notificaci&oacute;n a la otra Parte por lo menos 30 (treinta) d&iacute;as</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En caso de que el Cliente realice la portaci&oacute;n de la base total de sus usuarios para que utilicen los servicios en una red diferente a la de Alt&aacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Que el Cliente cuente con la plataforma y/o software para dar contestaci&oacute;n a los requerimientos relacionados con las obligaciones en materia de seguridad y</li>
</ol>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO QUINTA. Matriz de Escalamiento</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En caso de que el Cliente no reciba en los plazos se&ntilde;alados en la Tabla 2 la informaci&oacute;n solicitada, el Cliente deber&aacute; atender la siguiente matriz:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="246">
<p><strong>Nivel</strong></p>
</td>
<td width="142">
<p><strong>Contacto</strong></p>
</td>
<td width="135">
<p><strong>Plazo de Alt&aacute;n</strong></p>
</td>
</tr>
<tr>
<td width="246">
<p>Responsable Seguridad y Justicia</p>
</td>
<td width="142">
<p>(55) 8633 6166</p>
</td>
<td width="135">
<p>1 hora</p>
</td>
</tr>
<tr>
<td width="246">
<p>Director de Cuenta</p>
</td>
<td width="142">
<p>(729) 518 3107</p>
</td>
<td width="135">
<p>2 horas</p>
</td>
</tr>
<tr>
<td width="246">
<p>Director Comercial</p>
</td>
<td width="142">
<p>(55) 2601 3977</p>
</td>
<td width="135">
<p>3 horas</p>
</td>
</tr>
<tr>
<td width="246">
<p>Director General</p>
</td>
<td width="142">
<p>(55) 2601 3951</p>
</td>
<td width="135">
<p>5 horas</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE LA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO; SIGUE P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance&nbsp; legal,&nbsp; las&nbsp; Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>

<p><strong>FORMATO DE COADYUVANCIA</strong></p>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td width="604">
<p><strong>Denominaci&oacute;n o Raz&oacute;n social del Cliente:</strong></p>
<p><strong><u>&nbsp;</u></strong><strong><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong><strong>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>1. Declaro bajo protesta de decir verdad que se ha realizado la validaci&oacute;n de las competencias y facultades de la Autoridad y del Oficio; y que el mismo se encuentra debidamente fundado</strong></p>
<p><strong>y motivado, mismo que se ha emitido por una Autoridad en ejercicio de sus funciones de investigaci&oacute;n de delitos y en su esfera de competencia.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>2. Se&ntilde;ale el tipo de obligaci&oacute;n en materia de seguridad </strong>Localizaci&oacute;n geogr&aacute;fica de los equipos terminales. Entrega de datos conservados.</p>
<p>Intervenci&oacute;n de comunicaciones.</p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>3. N&uacute;mero(s) telef&oacute;nico(s) a diez d&iacute;gitos objeto del Oficio o IMEI (&uacute;nicamente aplica para entrega de datos conservados)<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>4. Fecha [<u> &nbsp;&nbsp;&nbsp;&nbsp; /&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp; </u>&nbsp;_]&nbsp; y&nbsp; hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>] de recepci&oacute;n del Oficio y fecha [<u>&nbsp; </u>&nbsp;_/<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>] y hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>] de env&iacute;o del Oficio por parte del Cliente a Alt&aacute;n.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>5. Descripci&oacute;n del Oficio</strong></p>
<p><strong>N&uacute;mero&nbsp; del Oficio: ___________________________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>Autoridad: nombre<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>y cargo &nbsp;<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>&nbsp;Fecha y hora del Oficio [_ /_ /_ ]</strong></p>
<p><strong>Delito: _______________________________________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>AP / Carpeta de Investigaci&oacute;n __________________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>6.&nbsp;&nbsp;&nbsp; </strong><strong>Periodo a intervenir (Orden de Intervenci&oacute;n) / monitorear (geolocalizaci&oacute;n) o periodo de b&uacute;squeda (entrega de datos conservados):</strong></p>
<p><strong>Fecha del [<u> &nbsp;&nbsp;&nbsp;&nbsp; /&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp;&nbsp; </u>_] y hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>] hasta [<u>&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp;&nbsp; </u>_] y hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>].</strong></p>
<p><strong>6.1&nbsp;&nbsp;&nbsp; </strong><strong>En caso de ser Orden de Intervenci&oacute;n Legal:</strong></p>
<p><strong>N&uacute;mero de Orden de Intervenci&oacute;n Legal _________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>Autoridad: Nombre<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>__ y Cargo _____________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>N&uacute;mero(s) telef&oacute;nico(s) a diez d&iacute;gitos objeto del Oficio ____________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>En caso de presentarse una ampliaci&oacute;n del plazo concedido por la Autoridad Facultada se&ntilde;alar el Oficio/Orden origen de la Intervenci&oacute;n: _<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>_</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>Mediante este Formato de Coadyuvancia, el Cliente solicita los servicios seleccionados en el numeral 2 del presente, quedando enterado de los alcances, responsabilidades y tarifas de los mismos, en t&eacute;rminos del Ap&eacute;ndice 11.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y</strong></p>
<p><strong>Administraci&oacute;n de Justicia&rdquo;.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>Bajo protesta de decir verdad, declaro que toda la informaci&oacute;n se&ntilde;alada en el presente Formato de Coadyuvancia es copia fiel del contenido del requerimiento judicial y el Cliente declara que ser&aacute; el &uacute;nico responsable de validar las competencias y facultades de la Autoridad y del requerimiento, por lo cual libera a Alt&aacute;n de cualquier responsabilidad que se genere en la atenci&oacute;n del mismo.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>&nbsp;</strong></p>
<p><strong>CLIENTE</strong></p>
<p><strong><u>&nbsp;</u></strong><strong><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong><strong>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p>Nombre: Apoderado:</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>

  </div>
</template>

<script>
export default {
}
</script>
